/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppWalletOpsRouteImport } from './routes/_app/wallet-ops'
import { Route as AppUsersRouteImport } from './routes/_app/users'
import { Route as AppTreasuryRouteImport } from './routes/_app/treasury'
import { Route as AppTradesRouteImport } from './routes/_app/trades'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppPositionsRouteImport } from './routes/_app/positions'
import { Route as AppOpsRouteImport } from './routes/_app/ops'
import { Route as AppMarketsRouteImport } from './routes/_app/markets'
import { Route as AppLeaguesRouteImport } from './routes/_app/leagues'
import { Route as AppLanguagesRouteImport } from './routes/_app/languages'
import { Route as AppGlobalLeagueRouteImport } from './routes/_app/global-league'
import { Route as AppEventOrderingRouteImport } from './routes/_app/event-ordering'
import { Route as AppEngineRouteImport } from './routes/_app/engine'
import { Route as AppCurrenciesRouteImport } from './routes/_app/currencies'
import { Route as AppAuditRouteImport } from './routes/_app/audit'
import { Route as AppAiConsentRouteImport } from './routes/_app/ai-consent'
import { Route as AppAdminsRouteImport } from './routes/_app/admins'
import { Route as AppWalletOpsIndexRouteImport } from './routes/_app/wallet-ops.index'
import { Route as AppTreasuryIndexRouteImport } from './routes/_app/treasury.index'
import { Route as AppOrdersIndexRouteImport } from './routes/_app/orders.index'
import { Route as AppOpsIndexRouteImport } from './routes/_app/ops.index'
import { Route as AppMarketsIndexRouteImport } from './routes/_app/markets.index'
import { Route as AppDisputesIndexRouteImport } from './routes/_app/disputes.index'
import { Route as AppCampaignsIndexRouteImport } from './routes/_app/campaigns.index'
import { Route as AppBrokersIndexRouteImport } from './routes/_app/brokers.index'
import { Route as AppAdminsIndexRouteImport } from './routes/_app/admins.index'
import { Route as AppWalletOpsWithdrawalsRouteImport } from './routes/_app/wallet-ops.withdrawals'
import { Route as AppWalletOpsOrdersRouteImport } from './routes/_app/wallet-ops.orders'
import { Route as AppWalletOpsLiquidityRouteImport } from './routes/_app/wallet-ops.liquidity'
import { Route as AppWalletOpsHealthRouteImport } from './routes/_app/wallet-ops.health'
import { Route as AppWalletOpsGasRouteImport } from './routes/_app/wallet-ops.gas'
import { Route as AppWalletOpsDepositsRouteImport } from './routes/_app/wallet-ops.deposits'
import { Route as AppWalletOpsCustodyRouteImport } from './routes/_app/wallet-ops.custody'
import { Route as AppWalletOpsCollectionsRouteImport } from './routes/_app/wallet-ops.collections'
import { Route as AppWalletOpsBlacklistRouteImport } from './routes/_app/wallet-ops.blacklist'
import { Route as AppUsersIdRouteImport } from './routes/_app/users.$id'
import { Route as AppTreasuryTransferRouteImport } from './routes/_app/treasury.transfer'
import { Route as AppTreasuryRevenueRouteImport } from './routes/_app/treasury.revenue'
import { Route as AppTreasuryPoolsRouteImport } from './routes/_app/treasury.pools'
import { Route as AppTreasuryPayoutsRouteImport } from './routes/_app/treasury.payouts'
import { Route as AppTreasuryFeesRouteImport } from './routes/_app/treasury.fees'
import { Route as AppTreasuryAccountsRouteImport } from './routes/_app/treasury.accounts'
import { Route as AppTreasuryIdRouteImport } from './routes/_app/treasury.$id'
import { Route as AppOrdersHistoryRouteImport } from './routes/_app/orders.history'
import { Route as AppOpsProviderRouteImport } from './routes/_app/ops.provider'
import { Route as AppMeBalanceRouteImport } from './routes/_app/me.balance'
import { Route as AppLeaguesIdRouteImport } from './routes/_app/leagues.$id'
import { Route as AppDisputesPolicyRouteImport } from './routes/_app/disputes.policy'
import { Route as AppDisputesAlertsRouteImport } from './routes/_app/disputes.alerts'
import { Route as AppDisputesIdRouteImport } from './routes/_app/disputes.$id'
import { Route as AppCampaignsIdRouteImport } from './routes/_app/campaigns.$id'
import { Route as AppBrokersRiskRouteImport } from './routes/_app/brokers.risk'
import { Route as AppBrokersReconciliationRouteImport } from './routes/_app/brokers.reconciliation'
import { Route as AppBrokersReceivablesRouteImport } from './routes/_app/brokers.receivables'
import { Route as AppBrokersPayoutsRouteImport } from './routes/_app/brokers.payouts'
import { Route as AppBrokersLifecycleRouteImport } from './routes/_app/brokers.lifecycle'
import { Route as AppBrokersInvestigateRouteImport } from './routes/_app/brokers.investigate'
import { Route as AppBrokersIntegrationsRouteImport } from './routes/_app/brokers.integrations'
import { Route as AppBrokersFundingRouteImport } from './routes/_app/brokers.funding'
import { Route as AppBrokersIdRouteImport } from './routes/_app/brokers.$id'
import { Route as AppAiUsageRouteImport } from './routes/_app/ai.usage'
import { Route as AppAiPolicyRouteImport } from './routes/_app/ai.policy'
import { Route as AppAiConnectionsRouteImport } from './routes/_app/ai.connections'
import { Route as AppAiApprovalsRouteImport } from './routes/_app/ai.approvals'
import { Route as AppAdminsRolesRouteImport } from './routes/_app/admins.roles'
import { Route as AppAdminsIdRouteImport } from './routes/_app/admins.$id'
import { Route as AppWalletOpsConfigIndexRouteImport } from './routes/_app/wallet-ops.config.index'
import { Route as AppTreasuryRevenueIndexRouteImport } from './routes/_app/treasury.revenue.index'
import { Route as AppTreasuryFeesIndexRouteImport } from './routes/_app/treasury.fees.index'
import { Route as AppOpsRunsIndexRouteImport } from './routes/_app/ops.runs.index'
import { Route as AppOpsFindingsIndexRouteImport } from './routes/_app/ops.findings.index'
import { Route as AppOpsBrokersIndexRouteImport } from './routes/_app/ops.brokers.index'
import { Route as AppBrokersSettlementIndexRouteImport } from './routes/_app/brokers.settlement.index'
import { Route as AppBrokersProviderCasesIndexRouteImport } from './routes/_app/brokers.provider-cases.index'
import { Route as AppWalletOpsConfigRailsRouteImport } from './routes/_app/wallet-ops.config.rails'
import { Route as AppWalletOpsConfigPoliciesRouteImport } from './routes/_app/wallet-ops.config.policies'
import { Route as AppWalletOpsConfigNetworkRouteImport } from './routes/_app/wallet-ops.config.network'
import { Route as AppWalletOpsConfigFlagsRouteImport } from './routes/_app/wallet-ops.config.flags'
import { Route as AppWalletOpsConfigAssetsRouteImport } from './routes/_app/wallet-ops.config.assets'
import { Route as AppWalletOpsConfigAssetRatesRouteImport } from './routes/_app/wallet-ops.config.asset-rates'
import { Route as AppTreasuryRevenuePoliciesRouteImport } from './routes/_app/treasury.revenue.policies'
import { Route as AppTreasuryRevenueDistributionsRouteImport } from './routes/_app/treasury.revenue.distributions'
import { Route as AppTreasuryRevenueCommissionsRouteImport } from './routes/_app/treasury.revenue.commissions'
import { Route as AppTreasuryFeesUsersRouteImport } from './routes/_app/treasury.fees.users'
import { Route as AppTreasuryFeesRedeemRouteImport } from './routes/_app/treasury.fees.redeem'
import { Route as AppTreasuryFeesActivityRouteImport } from './routes/_app/treasury.fees.activity'
import { Route as AppTreasuryAccountsCodeRouteImport } from './routes/_app/treasury.accounts.$code'
import { Route as AppOpsTradesTradeIdRouteImport } from './routes/_app/ops.trades.$tradeId'
import { Route as AppOpsRunsIdRouteImport } from './routes/_app/ops.runs.$id'
import { Route as AppOpsFindingsIdRouteImport } from './routes/_app/ops.findings.$id'
import { Route as AppOpsBrokersBrokerIdRouteImport } from './routes/_app/ops.brokers.$brokerId'
import { Route as AppBrokersSettlementBrokerIdRouteImport } from './routes/_app/brokers.settlement.$brokerId'
import { Route as AppBrokersProviderCasesCaseIdRouteImport } from './routes/_app/brokers.provider-cases.$caseId'
import { Route as AppWalletOpsConfigPoliciesIndexRouteImport } from './routes/_app/wallet-ops.config.policies.index'
import { Route as AppTreasuryFeesPoliciesIndexRouteImport } from './routes/_app/treasury.fees.policies.index'
import { Route as AppWalletOpsConfigPoliciesWithdrawalRouteImport } from './routes/_app/wallet-ops.config.policies.withdrawal'
import { Route as AppWalletOpsConfigPoliciesLiquidityRouteImport } from './routes/_app/wallet-ops.config.policies.liquidity'
import { Route as AppWalletOpsConfigPoliciesGasRouteImport } from './routes/_app/wallet-ops.config.policies.gas'
import { Route as AppWalletOpsConfigPoliciesCollectionRouteImport } from './routes/_app/wallet-ops.config.policies.collection'
import { Route as AppTreasuryRevenueMarketsMarketIdRouteImport } from './routes/_app/treasury.revenue.markets.$marketId'
import { Route as AppTreasuryRevenueEventsEventIdRouteImport } from './routes/_app/treasury.revenue.events.$eventId'
import { Route as AppTreasuryFeesPoliciesNewRouteImport } from './routes/_app/treasury.fees.policies.new'
import { Route as AppTreasuryFeesPoliciesProfileIdRouteImport } from './routes/_app/treasury.fees.policies.$profileId'
import { Route as AppOpsWalletsWalletIdFlowsRouteImport } from './routes/_app/ops.wallets.$walletId.flows'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppWalletOpsRoute = AppWalletOpsRouteImport.update({
  id: '/wallet-ops',
  path: '/wallet-ops',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppTreasuryRoute = AppTreasuryRouteImport.update({
  id: '/treasury',
  path: '/treasury',
  getParentRoute: () => AppRoute,
} as any)
const AppTradesRoute = AppTradesRouteImport.update({
  id: '/trades',
  path: '/trades',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppPositionsRoute = AppPositionsRouteImport.update({
  id: '/positions',
  path: '/positions',
  getParentRoute: () => AppRoute,
} as any)
const AppOpsRoute = AppOpsRouteImport.update({
  id: '/ops',
  path: '/ops',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketsRoute = AppMarketsRouteImport.update({
  id: '/markets',
  path: '/markets',
  getParentRoute: () => AppRoute,
} as any)
const AppLeaguesRoute = AppLeaguesRouteImport.update({
  id: '/leagues',
  path: '/leagues',
  getParentRoute: () => AppRoute,
} as any)
const AppLanguagesRoute = AppLanguagesRouteImport.update({
  id: '/languages',
  path: '/languages',
  getParentRoute: () => AppRoute,
} as any)
const AppGlobalLeagueRoute = AppGlobalLeagueRouteImport.update({
  id: '/global-league',
  path: '/global-league',
  getParentRoute: () => AppRoute,
} as any)
const AppEventOrderingRoute = AppEventOrderingRouteImport.update({
  id: '/event-ordering',
  path: '/event-ordering',
  getParentRoute: () => AppRoute,
} as any)
const AppEngineRoute = AppEngineRouteImport.update({
  id: '/engine',
  path: '/engine',
  getParentRoute: () => AppRoute,
} as any)
const AppCurrenciesRoute = AppCurrenciesRouteImport.update({
  id: '/currencies',
  path: '/currencies',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppAiConsentRoute = AppAiConsentRouteImport.update({
  id: '/ai-consent',
  path: '/ai-consent',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminsRoute = AppAdminsRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => AppRoute,
} as any)
const AppWalletOpsIndexRoute = AppWalletOpsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppWalletOpsRoute,
} as any)
const AppTreasuryIndexRoute = AppTreasuryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTreasuryRoute,
} as any)
const AppOrdersIndexRoute = AppOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AppRoute,
} as any)
const AppOpsIndexRoute = AppOpsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOpsRoute,
} as any)
const AppMarketsIndexRoute = AppMarketsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMarketsRoute,
} as any)
const AppDisputesIndexRoute = AppDisputesIndexRouteImport.update({
  id: '/disputes/',
  path: '/disputes/',
  getParentRoute: () => AppRoute,
} as any)
const AppCampaignsIndexRoute = AppCampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => AppRoute,
} as any)
const AppBrokersIndexRoute = AppBrokersIndexRouteImport.update({
  id: '/brokers/',
  path: '/brokers/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminsIndexRoute = AppAdminsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminsRoute,
} as any)
const AppWalletOpsWithdrawalsRoute = AppWalletOpsWithdrawalsRouteImport.update({
  id: '/withdrawals',
  path: '/withdrawals',
  getParentRoute: () => AppWalletOpsRoute,
} as any)
const AppWalletOpsOrdersRoute = AppWalletOpsOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppWalletOpsRoute,
} as any)
const AppWalletOpsLiquidityRoute = AppWalletOpsLiquidityRouteImport.update({
  id: '/liquidity',
  path: '/liquidity',
  getParentRoute: () => AppWalletOpsRoute,
} as any)
const AppWalletOpsHealthRoute = AppWalletOpsHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => AppWalletOpsRoute,
} as any)
const AppWalletOpsGasRoute = AppWalletOpsGasRouteImport.update({
  id: '/gas',
  path: '/gas',
  getParentRoute: () => AppWalletOpsRoute,
} as any)
const AppWalletOpsDepositsRoute = AppWalletOpsDepositsRouteImport.update({
  id: '/deposits',
  path: '/deposits',
  getParentRoute: () => AppWalletOpsRoute,
} as any)
const AppWalletOpsCustodyRoute = AppWalletOpsCustodyRouteImport.update({
  id: '/custody',
  path: '/custody',
  getParentRoute: () => AppWalletOpsRoute,
} as any)
const AppWalletOpsCollectionsRoute = AppWalletOpsCollectionsRouteImport.update({
  id: '/collections',
  path: '/collections',
  getParentRoute: () => AppWalletOpsRoute,
} as any)
const AppWalletOpsBlacklistRoute = AppWalletOpsBlacklistRouteImport.update({
  id: '/blacklist',
  path: '/blacklist',
  getParentRoute: () => AppWalletOpsRoute,
} as any)
const AppUsersIdRoute = AppUsersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppUsersRoute,
} as any)
const AppTreasuryTransferRoute = AppTreasuryTransferRouteImport.update({
  id: '/transfer',
  path: '/transfer',
  getParentRoute: () => AppTreasuryRoute,
} as any)
const AppTreasuryRevenueRoute = AppTreasuryRevenueRouteImport.update({
  id: '/revenue',
  path: '/revenue',
  getParentRoute: () => AppTreasuryRoute,
} as any)
const AppTreasuryPoolsRoute = AppTreasuryPoolsRouteImport.update({
  id: '/pools',
  path: '/pools',
  getParentRoute: () => AppTreasuryRoute,
} as any)
const AppTreasuryPayoutsRoute = AppTreasuryPayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => AppTreasuryRoute,
} as any)
const AppTreasuryFeesRoute = AppTreasuryFeesRouteImport.update({
  id: '/fees',
  path: '/fees',
  getParentRoute: () => AppTreasuryRoute,
} as any)
const AppTreasuryAccountsRoute = AppTreasuryAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AppTreasuryRoute,
} as any)
const AppTreasuryIdRoute = AppTreasuryIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppTreasuryRoute,
} as any)
const AppOrdersHistoryRoute = AppOrdersHistoryRouteImport.update({
  id: '/orders/history',
  path: '/orders/history',
  getParentRoute: () => AppRoute,
} as any)
const AppOpsProviderRoute = AppOpsProviderRouteImport.update({
  id: '/provider',
  path: '/provider',
  getParentRoute: () => AppOpsRoute,
} as any)
const AppMeBalanceRoute = AppMeBalanceRouteImport.update({
  id: '/me/balance',
  path: '/me/balance',
  getParentRoute: () => AppRoute,
} as any)
const AppLeaguesIdRoute = AppLeaguesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppLeaguesRoute,
} as any)
const AppDisputesPolicyRoute = AppDisputesPolicyRouteImport.update({
  id: '/disputes/policy',
  path: '/disputes/policy',
  getParentRoute: () => AppRoute,
} as any)
const AppDisputesAlertsRoute = AppDisputesAlertsRouteImport.update({
  id: '/disputes/alerts',
  path: '/disputes/alerts',
  getParentRoute: () => AppRoute,
} as any)
const AppDisputesIdRoute = AppDisputesIdRouteImport.update({
  id: '/disputes/$id',
  path: '/disputes/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCampaignsIdRoute = AppCampaignsIdRouteImport.update({
  id: '/campaigns/$id',
  path: '/campaigns/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppBrokersRiskRoute = AppBrokersRiskRouteImport.update({
  id: '/brokers/risk',
  path: '/brokers/risk',
  getParentRoute: () => AppRoute,
} as any)
const AppBrokersReconciliationRoute =
  AppBrokersReconciliationRouteImport.update({
    id: '/brokers/reconciliation',
    path: '/brokers/reconciliation',
    getParentRoute: () => AppRoute,
  } as any)
const AppBrokersReceivablesRoute = AppBrokersReceivablesRouteImport.update({
  id: '/brokers/receivables',
  path: '/brokers/receivables',
  getParentRoute: () => AppRoute,
} as any)
const AppBrokersPayoutsRoute = AppBrokersPayoutsRouteImport.update({
  id: '/brokers/payouts',
  path: '/brokers/payouts',
  getParentRoute: () => AppRoute,
} as any)
const AppBrokersLifecycleRoute = AppBrokersLifecycleRouteImport.update({
  id: '/brokers/lifecycle',
  path: '/brokers/lifecycle',
  getParentRoute: () => AppRoute,
} as any)
const AppBrokersInvestigateRoute = AppBrokersInvestigateRouteImport.update({
  id: '/brokers/investigate',
  path: '/brokers/investigate',
  getParentRoute: () => AppRoute,
} as any)
const AppBrokersIntegrationsRoute = AppBrokersIntegrationsRouteImport.update({
  id: '/brokers/integrations',
  path: '/brokers/integrations',
  getParentRoute: () => AppRoute,
} as any)
const AppBrokersFundingRoute = AppBrokersFundingRouteImport.update({
  id: '/brokers/funding',
  path: '/brokers/funding',
  getParentRoute: () => AppRoute,
} as any)
const AppBrokersIdRoute = AppBrokersIdRouteImport.update({
  id: '/brokers/$id',
  path: '/brokers/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAiUsageRoute = AppAiUsageRouteImport.update({
  id: '/ai/usage',
  path: '/ai/usage',
  getParentRoute: () => AppRoute,
} as any)
const AppAiPolicyRoute = AppAiPolicyRouteImport.update({
  id: '/ai/policy',
  path: '/ai/policy',
  getParentRoute: () => AppRoute,
} as any)
const AppAiConnectionsRoute = AppAiConnectionsRouteImport.update({
  id: '/ai/connections',
  path: '/ai/connections',
  getParentRoute: () => AppRoute,
} as any)
const AppAiApprovalsRoute = AppAiApprovalsRouteImport.update({
  id: '/ai/approvals',
  path: '/ai/approvals',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminsRolesRoute = AppAdminsRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AppAdminsRoute,
} as any)
const AppAdminsIdRoute = AppAdminsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppAdminsRoute,
} as any)
const AppWalletOpsConfigIndexRoute = AppWalletOpsConfigIndexRouteImport.update({
  id: '/config/',
  path: '/config/',
  getParentRoute: () => AppWalletOpsRoute,
} as any)
const AppTreasuryRevenueIndexRoute = AppTreasuryRevenueIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTreasuryRevenueRoute,
} as any)
const AppTreasuryFeesIndexRoute = AppTreasuryFeesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTreasuryFeesRoute,
} as any)
const AppOpsRunsIndexRoute = AppOpsRunsIndexRouteImport.update({
  id: '/runs/',
  path: '/runs/',
  getParentRoute: () => AppOpsRoute,
} as any)
const AppOpsFindingsIndexRoute = AppOpsFindingsIndexRouteImport.update({
  id: '/findings/',
  path: '/findings/',
  getParentRoute: () => AppOpsRoute,
} as any)
const AppOpsBrokersIndexRoute = AppOpsBrokersIndexRouteImport.update({
  id: '/brokers/',
  path: '/brokers/',
  getParentRoute: () => AppOpsRoute,
} as any)
const AppBrokersSettlementIndexRoute =
  AppBrokersSettlementIndexRouteImport.update({
    id: '/brokers/settlement/',
    path: '/brokers/settlement/',
    getParentRoute: () => AppRoute,
  } as any)
const AppBrokersProviderCasesIndexRoute =
  AppBrokersProviderCasesIndexRouteImport.update({
    id: '/brokers/provider-cases/',
    path: '/brokers/provider-cases/',
    getParentRoute: () => AppRoute,
  } as any)
const AppWalletOpsConfigRailsRoute = AppWalletOpsConfigRailsRouteImport.update({
  id: '/config/rails',
  path: '/config/rails',
  getParentRoute: () => AppWalletOpsRoute,
} as any)
const AppWalletOpsConfigPoliciesRoute =
  AppWalletOpsConfigPoliciesRouteImport.update({
    id: '/config/policies',
    path: '/config/policies',
    getParentRoute: () => AppWalletOpsRoute,
  } as any)
const AppWalletOpsConfigNetworkRoute =
  AppWalletOpsConfigNetworkRouteImport.update({
    id: '/config/network',
    path: '/config/network',
    getParentRoute: () => AppWalletOpsRoute,
  } as any)
const AppWalletOpsConfigFlagsRoute = AppWalletOpsConfigFlagsRouteImport.update({
  id: '/config/flags',
  path: '/config/flags',
  getParentRoute: () => AppWalletOpsRoute,
} as any)
const AppWalletOpsConfigAssetsRoute =
  AppWalletOpsConfigAssetsRouteImport.update({
    id: '/config/assets',
    path: '/config/assets',
    getParentRoute: () => AppWalletOpsRoute,
  } as any)
const AppWalletOpsConfigAssetRatesRoute =
  AppWalletOpsConfigAssetRatesRouteImport.update({
    id: '/config/asset-rates',
    path: '/config/asset-rates',
    getParentRoute: () => AppWalletOpsRoute,
  } as any)
const AppTreasuryRevenuePoliciesRoute =
  AppTreasuryRevenuePoliciesRouteImport.update({
    id: '/policies',
    path: '/policies',
    getParentRoute: () => AppTreasuryRevenueRoute,
  } as any)
const AppTreasuryRevenueDistributionsRoute =
  AppTreasuryRevenueDistributionsRouteImport.update({
    id: '/distributions',
    path: '/distributions',
    getParentRoute: () => AppTreasuryRevenueRoute,
  } as any)
const AppTreasuryRevenueCommissionsRoute =
  AppTreasuryRevenueCommissionsRouteImport.update({
    id: '/commissions',
    path: '/commissions',
    getParentRoute: () => AppTreasuryRevenueRoute,
  } as any)
const AppTreasuryFeesUsersRoute = AppTreasuryFeesUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppTreasuryFeesRoute,
} as any)
const AppTreasuryFeesRedeemRoute = AppTreasuryFeesRedeemRouteImport.update({
  id: '/redeem',
  path: '/redeem',
  getParentRoute: () => AppTreasuryFeesRoute,
} as any)
const AppTreasuryFeesActivityRoute = AppTreasuryFeesActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppTreasuryFeesRoute,
} as any)
const AppTreasuryAccountsCodeRoute = AppTreasuryAccountsCodeRouteImport.update({
  id: '/$code',
  path: '/$code',
  getParentRoute: () => AppTreasuryAccountsRoute,
} as any)
const AppOpsTradesTradeIdRoute = AppOpsTradesTradeIdRouteImport.update({
  id: '/trades/$tradeId',
  path: '/trades/$tradeId',
  getParentRoute: () => AppOpsRoute,
} as any)
const AppOpsRunsIdRoute = AppOpsRunsIdRouteImport.update({
  id: '/runs/$id',
  path: '/runs/$id',
  getParentRoute: () => AppOpsRoute,
} as any)
const AppOpsFindingsIdRoute = AppOpsFindingsIdRouteImport.update({
  id: '/findings/$id',
  path: '/findings/$id',
  getParentRoute: () => AppOpsRoute,
} as any)
const AppOpsBrokersBrokerIdRoute = AppOpsBrokersBrokerIdRouteImport.update({
  id: '/brokers/$brokerId',
  path: '/brokers/$brokerId',
  getParentRoute: () => AppOpsRoute,
} as any)
const AppBrokersSettlementBrokerIdRoute =
  AppBrokersSettlementBrokerIdRouteImport.update({
    id: '/brokers/settlement/$brokerId',
    path: '/brokers/settlement/$brokerId',
    getParentRoute: () => AppRoute,
  } as any)
const AppBrokersProviderCasesCaseIdRoute =
  AppBrokersProviderCasesCaseIdRouteImport.update({
    id: '/brokers/provider-cases/$caseId',
    path: '/brokers/provider-cases/$caseId',
    getParentRoute: () => AppRoute,
  } as any)
const AppWalletOpsConfigPoliciesIndexRoute =
  AppWalletOpsConfigPoliciesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppWalletOpsConfigPoliciesRoute,
  } as any)
const AppTreasuryFeesPoliciesIndexRoute =
  AppTreasuryFeesPoliciesIndexRouteImport.update({
    id: '/policies/',
    path: '/policies/',
    getParentRoute: () => AppTreasuryFeesRoute,
  } as any)
const AppWalletOpsConfigPoliciesWithdrawalRoute =
  AppWalletOpsConfigPoliciesWithdrawalRouteImport.update({
    id: '/withdrawal',
    path: '/withdrawal',
    getParentRoute: () => AppWalletOpsConfigPoliciesRoute,
  } as any)
const AppWalletOpsConfigPoliciesLiquidityRoute =
  AppWalletOpsConfigPoliciesLiquidityRouteImport.update({
    id: '/liquidity',
    path: '/liquidity',
    getParentRoute: () => AppWalletOpsConfigPoliciesRoute,
  } as any)
const AppWalletOpsConfigPoliciesGasRoute =
  AppWalletOpsConfigPoliciesGasRouteImport.update({
    id: '/gas',
    path: '/gas',
    getParentRoute: () => AppWalletOpsConfigPoliciesRoute,
  } as any)
const AppWalletOpsConfigPoliciesCollectionRoute =
  AppWalletOpsConfigPoliciesCollectionRouteImport.update({
    id: '/collection',
    path: '/collection',
    getParentRoute: () => AppWalletOpsConfigPoliciesRoute,
  } as any)
const AppTreasuryRevenueMarketsMarketIdRoute =
  AppTreasuryRevenueMarketsMarketIdRouteImport.update({
    id: '/markets/$marketId',
    path: '/markets/$marketId',
    getParentRoute: () => AppTreasuryRevenueRoute,
  } as any)
const AppTreasuryRevenueEventsEventIdRoute =
  AppTreasuryRevenueEventsEventIdRouteImport.update({
    id: '/events/$eventId',
    path: '/events/$eventId',
    getParentRoute: () => AppTreasuryRevenueRoute,
  } as any)
const AppTreasuryFeesPoliciesNewRoute =
  AppTreasuryFeesPoliciesNewRouteImport.update({
    id: '/policies/new',
    path: '/policies/new',
    getParentRoute: () => AppTreasuryFeesRoute,
  } as any)
const AppTreasuryFeesPoliciesProfileIdRoute =
  AppTreasuryFeesPoliciesProfileIdRouteImport.update({
    id: '/policies/$profileId',
    path: '/policies/$profileId',
    getParentRoute: () => AppTreasuryFeesRoute,
  } as any)
const AppOpsWalletsWalletIdFlowsRoute =
  AppOpsWalletsWalletIdFlowsRouteImport.update({
    id: '/wallets/$walletId/flows',
    path: '/wallets/$walletId/flows',
    getParentRoute: () => AppOpsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/admins': typeof AppAdminsRouteWithChildren
  '/ai-consent': typeof AppAiConsentRoute
  '/audit': typeof AppAuditRoute
  '/currencies': typeof AppCurrenciesRoute
  '/engine': typeof AppEngineRoute
  '/event-ordering': typeof AppEventOrderingRoute
  '/global-league': typeof AppGlobalLeagueRoute
  '/languages': typeof AppLanguagesRoute
  '/leagues': typeof AppLeaguesRouteWithChildren
  '/markets': typeof AppMarketsRouteWithChildren
  '/ops': typeof AppOpsRouteWithChildren
  '/positions': typeof AppPositionsRoute
  '/settings': typeof AppSettingsRoute
  '/trades': typeof AppTradesRoute
  '/treasury': typeof AppTreasuryRouteWithChildren
  '/users': typeof AppUsersRouteWithChildren
  '/wallet-ops': typeof AppWalletOpsRouteWithChildren
  '/admins/$id': typeof AppAdminsIdRoute
  '/admins/roles': typeof AppAdminsRolesRoute
  '/ai/approvals': typeof AppAiApprovalsRoute
  '/ai/connections': typeof AppAiConnectionsRoute
  '/ai/policy': typeof AppAiPolicyRoute
  '/ai/usage': typeof AppAiUsageRoute
  '/brokers/$id': typeof AppBrokersIdRoute
  '/brokers/funding': typeof AppBrokersFundingRoute
  '/brokers/integrations': typeof AppBrokersIntegrationsRoute
  '/brokers/investigate': typeof AppBrokersInvestigateRoute
  '/brokers/lifecycle': typeof AppBrokersLifecycleRoute
  '/brokers/payouts': typeof AppBrokersPayoutsRoute
  '/brokers/receivables': typeof AppBrokersReceivablesRoute
  '/brokers/reconciliation': typeof AppBrokersReconciliationRoute
  '/brokers/risk': typeof AppBrokersRiskRoute
  '/campaigns/$id': typeof AppCampaignsIdRoute
  '/disputes/$id': typeof AppDisputesIdRoute
  '/disputes/alerts': typeof AppDisputesAlertsRoute
  '/disputes/policy': typeof AppDisputesPolicyRoute
  '/leagues/$id': typeof AppLeaguesIdRoute
  '/me/balance': typeof AppMeBalanceRoute
  '/ops/provider': typeof AppOpsProviderRoute
  '/orders/history': typeof AppOrdersHistoryRoute
  '/treasury/$id': typeof AppTreasuryIdRoute
  '/treasury/accounts': typeof AppTreasuryAccountsRouteWithChildren
  '/treasury/fees': typeof AppTreasuryFeesRouteWithChildren
  '/treasury/payouts': typeof AppTreasuryPayoutsRoute
  '/treasury/pools': typeof AppTreasuryPoolsRoute
  '/treasury/revenue': typeof AppTreasuryRevenueRouteWithChildren
  '/treasury/transfer': typeof AppTreasuryTransferRoute
  '/users/$id': typeof AppUsersIdRoute
  '/wallet-ops/blacklist': typeof AppWalletOpsBlacklistRoute
  '/wallet-ops/collections': typeof AppWalletOpsCollectionsRoute
  '/wallet-ops/custody': typeof AppWalletOpsCustodyRoute
  '/wallet-ops/deposits': typeof AppWalletOpsDepositsRoute
  '/wallet-ops/gas': typeof AppWalletOpsGasRoute
  '/wallet-ops/health': typeof AppWalletOpsHealthRoute
  '/wallet-ops/liquidity': typeof AppWalletOpsLiquidityRoute
  '/wallet-ops/orders': typeof AppWalletOpsOrdersRoute
  '/wallet-ops/withdrawals': typeof AppWalletOpsWithdrawalsRoute
  '/admins/': typeof AppAdminsIndexRoute
  '/brokers/': typeof AppBrokersIndexRoute
  '/campaigns/': typeof AppCampaignsIndexRoute
  '/disputes/': typeof AppDisputesIndexRoute
  '/markets/': typeof AppMarketsIndexRoute
  '/ops/': typeof AppOpsIndexRoute
  '/orders/': typeof AppOrdersIndexRoute
  '/treasury/': typeof AppTreasuryIndexRoute
  '/wallet-ops/': typeof AppWalletOpsIndexRoute
  '/brokers/provider-cases/$caseId': typeof AppBrokersProviderCasesCaseIdRoute
  '/brokers/settlement/$brokerId': typeof AppBrokersSettlementBrokerIdRoute
  '/ops/brokers/$brokerId': typeof AppOpsBrokersBrokerIdRoute
  '/ops/findings/$id': typeof AppOpsFindingsIdRoute
  '/ops/runs/$id': typeof AppOpsRunsIdRoute
  '/ops/trades/$tradeId': typeof AppOpsTradesTradeIdRoute
  '/treasury/accounts/$code': typeof AppTreasuryAccountsCodeRoute
  '/treasury/fees/activity': typeof AppTreasuryFeesActivityRoute
  '/treasury/fees/redeem': typeof AppTreasuryFeesRedeemRoute
  '/treasury/fees/users': typeof AppTreasuryFeesUsersRoute
  '/treasury/revenue/commissions': typeof AppTreasuryRevenueCommissionsRoute
  '/treasury/revenue/distributions': typeof AppTreasuryRevenueDistributionsRoute
  '/treasury/revenue/policies': typeof AppTreasuryRevenuePoliciesRoute
  '/wallet-ops/config/asset-rates': typeof AppWalletOpsConfigAssetRatesRoute
  '/wallet-ops/config/assets': typeof AppWalletOpsConfigAssetsRoute
  '/wallet-ops/config/flags': typeof AppWalletOpsConfigFlagsRoute
  '/wallet-ops/config/network': typeof AppWalletOpsConfigNetworkRoute
  '/wallet-ops/config/policies': typeof AppWalletOpsConfigPoliciesRouteWithChildren
  '/wallet-ops/config/rails': typeof AppWalletOpsConfigRailsRoute
  '/brokers/provider-cases/': typeof AppBrokersProviderCasesIndexRoute
  '/brokers/settlement/': typeof AppBrokersSettlementIndexRoute
  '/ops/brokers/': typeof AppOpsBrokersIndexRoute
  '/ops/findings/': typeof AppOpsFindingsIndexRoute
  '/ops/runs/': typeof AppOpsRunsIndexRoute
  '/treasury/fees/': typeof AppTreasuryFeesIndexRoute
  '/treasury/revenue/': typeof AppTreasuryRevenueIndexRoute
  '/wallet-ops/config/': typeof AppWalletOpsConfigIndexRoute
  '/ops/wallets/$walletId/flows': typeof AppOpsWalletsWalletIdFlowsRoute
  '/treasury/fees/policies/$profileId': typeof AppTreasuryFeesPoliciesProfileIdRoute
  '/treasury/fees/policies/new': typeof AppTreasuryFeesPoliciesNewRoute
  '/treasury/revenue/events/$eventId': typeof AppTreasuryRevenueEventsEventIdRoute
  '/treasury/revenue/markets/$marketId': typeof AppTreasuryRevenueMarketsMarketIdRoute
  '/wallet-ops/config/policies/collection': typeof AppWalletOpsConfigPoliciesCollectionRoute
  '/wallet-ops/config/policies/gas': typeof AppWalletOpsConfigPoliciesGasRoute
  '/wallet-ops/config/policies/liquidity': typeof AppWalletOpsConfigPoliciesLiquidityRoute
  '/wallet-ops/config/policies/withdrawal': typeof AppWalletOpsConfigPoliciesWithdrawalRoute
  '/treasury/fees/policies/': typeof AppTreasuryFeesPoliciesIndexRoute
  '/wallet-ops/config/policies/': typeof AppWalletOpsConfigPoliciesIndexRoute
}
export interface FileRoutesByTo {
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/ai-consent': typeof AppAiConsentRoute
  '/audit': typeof AppAuditRoute
  '/currencies': typeof AppCurrenciesRoute
  '/engine': typeof AppEngineRoute
  '/event-ordering': typeof AppEventOrderingRoute
  '/global-league': typeof AppGlobalLeagueRoute
  '/languages': typeof AppLanguagesRoute
  '/leagues': typeof AppLeaguesRouteWithChildren
  '/positions': typeof AppPositionsRoute
  '/settings': typeof AppSettingsRoute
  '/trades': typeof AppTradesRoute
  '/users': typeof AppUsersRouteWithChildren
  '/': typeof AppIndexRoute
  '/admins/$id': typeof AppAdminsIdRoute
  '/admins/roles': typeof AppAdminsRolesRoute
  '/ai/approvals': typeof AppAiApprovalsRoute
  '/ai/connections': typeof AppAiConnectionsRoute
  '/ai/policy': typeof AppAiPolicyRoute
  '/ai/usage': typeof AppAiUsageRoute
  '/brokers/$id': typeof AppBrokersIdRoute
  '/brokers/funding': typeof AppBrokersFundingRoute
  '/brokers/integrations': typeof AppBrokersIntegrationsRoute
  '/brokers/investigate': typeof AppBrokersInvestigateRoute
  '/brokers/lifecycle': typeof AppBrokersLifecycleRoute
  '/brokers/payouts': typeof AppBrokersPayoutsRoute
  '/brokers/receivables': typeof AppBrokersReceivablesRoute
  '/brokers/reconciliation': typeof AppBrokersReconciliationRoute
  '/brokers/risk': typeof AppBrokersRiskRoute
  '/campaigns/$id': typeof AppCampaignsIdRoute
  '/disputes/$id': typeof AppDisputesIdRoute
  '/disputes/alerts': typeof AppDisputesAlertsRoute
  '/disputes/policy': typeof AppDisputesPolicyRoute
  '/leagues/$id': typeof AppLeaguesIdRoute
  '/me/balance': typeof AppMeBalanceRoute
  '/ops/provider': typeof AppOpsProviderRoute
  '/orders/history': typeof AppOrdersHistoryRoute
  '/treasury/$id': typeof AppTreasuryIdRoute
  '/treasury/accounts': typeof AppTreasuryAccountsRouteWithChildren
  '/treasury/payouts': typeof AppTreasuryPayoutsRoute
  '/treasury/pools': typeof AppTreasuryPoolsRoute
  '/treasury/transfer': typeof AppTreasuryTransferRoute
  '/users/$id': typeof AppUsersIdRoute
  '/wallet-ops/blacklist': typeof AppWalletOpsBlacklistRoute
  '/wallet-ops/collections': typeof AppWalletOpsCollectionsRoute
  '/wallet-ops/custody': typeof AppWalletOpsCustodyRoute
  '/wallet-ops/deposits': typeof AppWalletOpsDepositsRoute
  '/wallet-ops/gas': typeof AppWalletOpsGasRoute
  '/wallet-ops/health': typeof AppWalletOpsHealthRoute
  '/wallet-ops/liquidity': typeof AppWalletOpsLiquidityRoute
  '/wallet-ops/orders': typeof AppWalletOpsOrdersRoute
  '/wallet-ops/withdrawals': typeof AppWalletOpsWithdrawalsRoute
  '/admins': typeof AppAdminsIndexRoute
  '/brokers': typeof AppBrokersIndexRoute
  '/campaigns': typeof AppCampaignsIndexRoute
  '/disputes': typeof AppDisputesIndexRoute
  '/markets': typeof AppMarketsIndexRoute
  '/ops': typeof AppOpsIndexRoute
  '/orders': typeof AppOrdersIndexRoute
  '/treasury': typeof AppTreasuryIndexRoute
  '/wallet-ops': typeof AppWalletOpsIndexRoute
  '/brokers/provider-cases/$caseId': typeof AppBrokersProviderCasesCaseIdRoute
  '/brokers/settlement/$brokerId': typeof AppBrokersSettlementBrokerIdRoute
  '/ops/brokers/$brokerId': typeof AppOpsBrokersBrokerIdRoute
  '/ops/findings/$id': typeof AppOpsFindingsIdRoute
  '/ops/runs/$id': typeof AppOpsRunsIdRoute
  '/ops/trades/$tradeId': typeof AppOpsTradesTradeIdRoute
  '/treasury/accounts/$code': typeof AppTreasuryAccountsCodeRoute
  '/treasury/fees/activity': typeof AppTreasuryFeesActivityRoute
  '/treasury/fees/redeem': typeof AppTreasuryFeesRedeemRoute
  '/treasury/fees/users': typeof AppTreasuryFeesUsersRoute
  '/treasury/revenue/commissions': typeof AppTreasuryRevenueCommissionsRoute
  '/treasury/revenue/distributions': typeof AppTreasuryRevenueDistributionsRoute
  '/treasury/revenue/policies': typeof AppTreasuryRevenuePoliciesRoute
  '/wallet-ops/config/asset-rates': typeof AppWalletOpsConfigAssetRatesRoute
  '/wallet-ops/config/assets': typeof AppWalletOpsConfigAssetsRoute
  '/wallet-ops/config/flags': typeof AppWalletOpsConfigFlagsRoute
  '/wallet-ops/config/network': typeof AppWalletOpsConfigNetworkRoute
  '/wallet-ops/config/rails': typeof AppWalletOpsConfigRailsRoute
  '/brokers/provider-cases': typeof AppBrokersProviderCasesIndexRoute
  '/brokers/settlement': typeof AppBrokersSettlementIndexRoute
  '/ops/brokers': typeof AppOpsBrokersIndexRoute
  '/ops/findings': typeof AppOpsFindingsIndexRoute
  '/ops/runs': typeof AppOpsRunsIndexRoute
  '/treasury/fees': typeof AppTreasuryFeesIndexRoute
  '/treasury/revenue': typeof AppTreasuryRevenueIndexRoute
  '/wallet-ops/config': typeof AppWalletOpsConfigIndexRoute
  '/ops/wallets/$walletId/flows': typeof AppOpsWalletsWalletIdFlowsRoute
  '/treasury/fees/policies/$profileId': typeof AppTreasuryFeesPoliciesProfileIdRoute
  '/treasury/fees/policies/new': typeof AppTreasuryFeesPoliciesNewRoute
  '/treasury/revenue/events/$eventId': typeof AppTreasuryRevenueEventsEventIdRoute
  '/treasury/revenue/markets/$marketId': typeof AppTreasuryRevenueMarketsMarketIdRoute
  '/wallet-ops/config/policies/collection': typeof AppWalletOpsConfigPoliciesCollectionRoute
  '/wallet-ops/config/policies/gas': typeof AppWalletOpsConfigPoliciesGasRoute
  '/wallet-ops/config/policies/liquidity': typeof AppWalletOpsConfigPoliciesLiquidityRoute
  '/wallet-ops/config/policies/withdrawal': typeof AppWalletOpsConfigPoliciesWithdrawalRoute
  '/treasury/fees/policies': typeof AppTreasuryFeesPoliciesIndexRoute
  '/wallet-ops/config/policies': typeof AppWalletOpsConfigPoliciesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/_app/admins': typeof AppAdminsRouteWithChildren
  '/_app/ai-consent': typeof AppAiConsentRoute
  '/_app/audit': typeof AppAuditRoute
  '/_app/currencies': typeof AppCurrenciesRoute
  '/_app/engine': typeof AppEngineRoute
  '/_app/event-ordering': typeof AppEventOrderingRoute
  '/_app/global-league': typeof AppGlobalLeagueRoute
  '/_app/languages': typeof AppLanguagesRoute
  '/_app/leagues': typeof AppLeaguesRouteWithChildren
  '/_app/markets': typeof AppMarketsRouteWithChildren
  '/_app/ops': typeof AppOpsRouteWithChildren
  '/_app/positions': typeof AppPositionsRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/trades': typeof AppTradesRoute
  '/_app/treasury': typeof AppTreasuryRouteWithChildren
  '/_app/users': typeof AppUsersRouteWithChildren
  '/_app/wallet-ops': typeof AppWalletOpsRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/admins/$id': typeof AppAdminsIdRoute
  '/_app/admins/roles': typeof AppAdminsRolesRoute
  '/_app/ai/approvals': typeof AppAiApprovalsRoute
  '/_app/ai/connections': typeof AppAiConnectionsRoute
  '/_app/ai/policy': typeof AppAiPolicyRoute
  '/_app/ai/usage': typeof AppAiUsageRoute
  '/_app/brokers/$id': typeof AppBrokersIdRoute
  '/_app/brokers/funding': typeof AppBrokersFundingRoute
  '/_app/brokers/integrations': typeof AppBrokersIntegrationsRoute
  '/_app/brokers/investigate': typeof AppBrokersInvestigateRoute
  '/_app/brokers/lifecycle': typeof AppBrokersLifecycleRoute
  '/_app/brokers/payouts': typeof AppBrokersPayoutsRoute
  '/_app/brokers/receivables': typeof AppBrokersReceivablesRoute
  '/_app/brokers/reconciliation': typeof AppBrokersReconciliationRoute
  '/_app/brokers/risk': typeof AppBrokersRiskRoute
  '/_app/campaigns/$id': typeof AppCampaignsIdRoute
  '/_app/disputes/$id': typeof AppDisputesIdRoute
  '/_app/disputes/alerts': typeof AppDisputesAlertsRoute
  '/_app/disputes/policy': typeof AppDisputesPolicyRoute
  '/_app/leagues/$id': typeof AppLeaguesIdRoute
  '/_app/me/balance': typeof AppMeBalanceRoute
  '/_app/ops/provider': typeof AppOpsProviderRoute
  '/_app/orders/history': typeof AppOrdersHistoryRoute
  '/_app/treasury/$id': typeof AppTreasuryIdRoute
  '/_app/treasury/accounts': typeof AppTreasuryAccountsRouteWithChildren
  '/_app/treasury/fees': typeof AppTreasuryFeesRouteWithChildren
  '/_app/treasury/payouts': typeof AppTreasuryPayoutsRoute
  '/_app/treasury/pools': typeof AppTreasuryPoolsRoute
  '/_app/treasury/revenue': typeof AppTreasuryRevenueRouteWithChildren
  '/_app/treasury/transfer': typeof AppTreasuryTransferRoute
  '/_app/users/$id': typeof AppUsersIdRoute
  '/_app/wallet-ops/blacklist': typeof AppWalletOpsBlacklistRoute
  '/_app/wallet-ops/collections': typeof AppWalletOpsCollectionsRoute
  '/_app/wallet-ops/custody': typeof AppWalletOpsCustodyRoute
  '/_app/wallet-ops/deposits': typeof AppWalletOpsDepositsRoute
  '/_app/wallet-ops/gas': typeof AppWalletOpsGasRoute
  '/_app/wallet-ops/health': typeof AppWalletOpsHealthRoute
  '/_app/wallet-ops/liquidity': typeof AppWalletOpsLiquidityRoute
  '/_app/wallet-ops/orders': typeof AppWalletOpsOrdersRoute
  '/_app/wallet-ops/withdrawals': typeof AppWalletOpsWithdrawalsRoute
  '/_app/admins/': typeof AppAdminsIndexRoute
  '/_app/brokers/': typeof AppBrokersIndexRoute
  '/_app/campaigns/': typeof AppCampaignsIndexRoute
  '/_app/disputes/': typeof AppDisputesIndexRoute
  '/_app/markets/': typeof AppMarketsIndexRoute
  '/_app/ops/': typeof AppOpsIndexRoute
  '/_app/orders/': typeof AppOrdersIndexRoute
  '/_app/treasury/': typeof AppTreasuryIndexRoute
  '/_app/wallet-ops/': typeof AppWalletOpsIndexRoute
  '/_app/brokers/provider-cases/$caseId': typeof AppBrokersProviderCasesCaseIdRoute
  '/_app/brokers/settlement/$brokerId': typeof AppBrokersSettlementBrokerIdRoute
  '/_app/ops/brokers/$brokerId': typeof AppOpsBrokersBrokerIdRoute
  '/_app/ops/findings/$id': typeof AppOpsFindingsIdRoute
  '/_app/ops/runs/$id': typeof AppOpsRunsIdRoute
  '/_app/ops/trades/$tradeId': typeof AppOpsTradesTradeIdRoute
  '/_app/treasury/accounts/$code': typeof AppTreasuryAccountsCodeRoute
  '/_app/treasury/fees/activity': typeof AppTreasuryFeesActivityRoute
  '/_app/treasury/fees/redeem': typeof AppTreasuryFeesRedeemRoute
  '/_app/treasury/fees/users': typeof AppTreasuryFeesUsersRoute
  '/_app/treasury/revenue/commissions': typeof AppTreasuryRevenueCommissionsRoute
  '/_app/treasury/revenue/distributions': typeof AppTreasuryRevenueDistributionsRoute
  '/_app/treasury/revenue/policies': typeof AppTreasuryRevenuePoliciesRoute
  '/_app/wallet-ops/config/asset-rates': typeof AppWalletOpsConfigAssetRatesRoute
  '/_app/wallet-ops/config/assets': typeof AppWalletOpsConfigAssetsRoute
  '/_app/wallet-ops/config/flags': typeof AppWalletOpsConfigFlagsRoute
  '/_app/wallet-ops/config/network': typeof AppWalletOpsConfigNetworkRoute
  '/_app/wallet-ops/config/policies': typeof AppWalletOpsConfigPoliciesRouteWithChildren
  '/_app/wallet-ops/config/rails': typeof AppWalletOpsConfigRailsRoute
  '/_app/brokers/provider-cases/': typeof AppBrokersProviderCasesIndexRoute
  '/_app/brokers/settlement/': typeof AppBrokersSettlementIndexRoute
  '/_app/ops/brokers/': typeof AppOpsBrokersIndexRoute
  '/_app/ops/findings/': typeof AppOpsFindingsIndexRoute
  '/_app/ops/runs/': typeof AppOpsRunsIndexRoute
  '/_app/treasury/fees/': typeof AppTreasuryFeesIndexRoute
  '/_app/treasury/revenue/': typeof AppTreasuryRevenueIndexRoute
  '/_app/wallet-ops/config/': typeof AppWalletOpsConfigIndexRoute
  '/_app/ops/wallets/$walletId/flows': typeof AppOpsWalletsWalletIdFlowsRoute
  '/_app/treasury/fees/policies/$profileId': typeof AppTreasuryFeesPoliciesProfileIdRoute
  '/_app/treasury/fees/policies/new': typeof AppTreasuryFeesPoliciesNewRoute
  '/_app/treasury/revenue/events/$eventId': typeof AppTreasuryRevenueEventsEventIdRoute
  '/_app/treasury/revenue/markets/$marketId': typeof AppTreasuryRevenueMarketsMarketIdRoute
  '/_app/wallet-ops/config/policies/collection': typeof AppWalletOpsConfigPoliciesCollectionRoute
  '/_app/wallet-ops/config/policies/gas': typeof AppWalletOpsConfigPoliciesGasRoute
  '/_app/wallet-ops/config/policies/liquidity': typeof AppWalletOpsConfigPoliciesLiquidityRoute
  '/_app/wallet-ops/config/policies/withdrawal': typeof AppWalletOpsConfigPoliciesWithdrawalRoute
  '/_app/treasury/fees/policies/': typeof AppTreasuryFeesPoliciesIndexRoute
  '/_app/wallet-ops/config/policies/': typeof AppWalletOpsConfigPoliciesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/change-password'
    | '/login'
    | '/admins'
    | '/ai-consent'
    | '/audit'
    | '/currencies'
    | '/engine'
    | '/event-ordering'
    | '/global-league'
    | '/languages'
    | '/leagues'
    | '/markets'
    | '/ops'
    | '/positions'
    | '/settings'
    | '/trades'
    | '/treasury'
    | '/users'
    | '/wallet-ops'
    | '/admins/$id'
    | '/admins/roles'
    | '/ai/approvals'
    | '/ai/connections'
    | '/ai/policy'
    | '/ai/usage'
    | '/brokers/$id'
    | '/brokers/funding'
    | '/brokers/integrations'
    | '/brokers/investigate'
    | '/brokers/lifecycle'
    | '/brokers/payouts'
    | '/brokers/receivables'
    | '/brokers/reconciliation'
    | '/brokers/risk'
    | '/campaigns/$id'
    | '/disputes/$id'
    | '/disputes/alerts'
    | '/disputes/policy'
    | '/leagues/$id'
    | '/me/balance'
    | '/ops/provider'
    | '/orders/history'
    | '/treasury/$id'
    | '/treasury/accounts'
    | '/treasury/fees'
    | '/treasury/payouts'
    | '/treasury/pools'
    | '/treasury/revenue'
    | '/treasury/transfer'
    | '/users/$id'
    | '/wallet-ops/blacklist'
    | '/wallet-ops/collections'
    | '/wallet-ops/custody'
    | '/wallet-ops/deposits'
    | '/wallet-ops/gas'
    | '/wallet-ops/health'
    | '/wallet-ops/liquidity'
    | '/wallet-ops/orders'
    | '/wallet-ops/withdrawals'
    | '/admins/'
    | '/brokers/'
    | '/campaigns/'
    | '/disputes/'
    | '/markets/'
    | '/ops/'
    | '/orders/'
    | '/treasury/'
    | '/wallet-ops/'
    | '/brokers/provider-cases/$caseId'
    | '/brokers/settlement/$brokerId'
    | '/ops/brokers/$brokerId'
    | '/ops/findings/$id'
    | '/ops/runs/$id'
    | '/ops/trades/$tradeId'
    | '/treasury/accounts/$code'
    | '/treasury/fees/activity'
    | '/treasury/fees/redeem'
    | '/treasury/fees/users'
    | '/treasury/revenue/commissions'
    | '/treasury/revenue/distributions'
    | '/treasury/revenue/policies'
    | '/wallet-ops/config/asset-rates'
    | '/wallet-ops/config/assets'
    | '/wallet-ops/config/flags'
    | '/wallet-ops/config/network'
    | '/wallet-ops/config/policies'
    | '/wallet-ops/config/rails'
    | '/brokers/provider-cases/'
    | '/brokers/settlement/'
    | '/ops/brokers/'
    | '/ops/findings/'
    | '/ops/runs/'
    | '/treasury/fees/'
    | '/treasury/revenue/'
    | '/wallet-ops/config/'
    | '/ops/wallets/$walletId/flows'
    | '/treasury/fees/policies/$profileId'
    | '/treasury/fees/policies/new'
    | '/treasury/revenue/events/$eventId'
    | '/treasury/revenue/markets/$marketId'
    | '/wallet-ops/config/policies/collection'
    | '/wallet-ops/config/policies/gas'
    | '/wallet-ops/config/policies/liquidity'
    | '/wallet-ops/config/policies/withdrawal'
    | '/treasury/fees/policies/'
    | '/wallet-ops/config/policies/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/change-password'
    | '/login'
    | '/ai-consent'
    | '/audit'
    | '/currencies'
    | '/engine'
    | '/event-ordering'
    | '/global-league'
    | '/languages'
    | '/leagues'
    | '/positions'
    | '/settings'
    | '/trades'
    | '/users'
    | '/'
    | '/admins/$id'
    | '/admins/roles'
    | '/ai/approvals'
    | '/ai/connections'
    | '/ai/policy'
    | '/ai/usage'
    | '/brokers/$id'
    | '/brokers/funding'
    | '/brokers/integrations'
    | '/brokers/investigate'
    | '/brokers/lifecycle'
    | '/brokers/payouts'
    | '/brokers/receivables'
    | '/brokers/reconciliation'
    | '/brokers/risk'
    | '/campaigns/$id'
    | '/disputes/$id'
    | '/disputes/alerts'
    | '/disputes/policy'
    | '/leagues/$id'
    | '/me/balance'
    | '/ops/provider'
    | '/orders/history'
    | '/treasury/$id'
    | '/treasury/accounts'
    | '/treasury/payouts'
    | '/treasury/pools'
    | '/treasury/transfer'
    | '/users/$id'
    | '/wallet-ops/blacklist'
    | '/wallet-ops/collections'
    | '/wallet-ops/custody'
    | '/wallet-ops/deposits'
    | '/wallet-ops/gas'
    | '/wallet-ops/health'
    | '/wallet-ops/liquidity'
    | '/wallet-ops/orders'
    | '/wallet-ops/withdrawals'
    | '/admins'
    | '/brokers'
    | '/campaigns'
    | '/disputes'
    | '/markets'
    | '/ops'
    | '/orders'
    | '/treasury'
    | '/wallet-ops'
    | '/brokers/provider-cases/$caseId'
    | '/brokers/settlement/$brokerId'
    | '/ops/brokers/$brokerId'
    | '/ops/findings/$id'
    | '/ops/runs/$id'
    | '/ops/trades/$tradeId'
    | '/treasury/accounts/$code'
    | '/treasury/fees/activity'
    | '/treasury/fees/redeem'
    | '/treasury/fees/users'
    | '/treasury/revenue/commissions'
    | '/treasury/revenue/distributions'
    | '/treasury/revenue/policies'
    | '/wallet-ops/config/asset-rates'
    | '/wallet-ops/config/assets'
    | '/wallet-ops/config/flags'
    | '/wallet-ops/config/network'
    | '/wallet-ops/config/rails'
    | '/brokers/provider-cases'
    | '/brokers/settlement'
    | '/ops/brokers'
    | '/ops/findings'
    | '/ops/runs'
    | '/treasury/fees'
    | '/treasury/revenue'
    | '/wallet-ops/config'
    | '/ops/wallets/$walletId/flows'
    | '/treasury/fees/policies/$profileId'
    | '/treasury/fees/policies/new'
    | '/treasury/revenue/events/$eventId'
    | '/treasury/revenue/markets/$marketId'
    | '/wallet-ops/config/policies/collection'
    | '/wallet-ops/config/policies/gas'
    | '/wallet-ops/config/policies/liquidity'
    | '/wallet-ops/config/policies/withdrawal'
    | '/treasury/fees/policies'
    | '/wallet-ops/config/policies'
  id:
    | '__root__'
    | '/_app'
    | '/change-password'
    | '/login'
    | '/_app/admins'
    | '/_app/ai-consent'
    | '/_app/audit'
    | '/_app/currencies'
    | '/_app/engine'
    | '/_app/event-ordering'
    | '/_app/global-league'
    | '/_app/languages'
    | '/_app/leagues'
    | '/_app/markets'
    | '/_app/ops'
    | '/_app/positions'
    | '/_app/settings'
    | '/_app/trades'
    | '/_app/treasury'
    | '/_app/users'
    | '/_app/wallet-ops'
    | '/_app/'
    | '/_app/admins/$id'
    | '/_app/admins/roles'
    | '/_app/ai/approvals'
    | '/_app/ai/connections'
    | '/_app/ai/policy'
    | '/_app/ai/usage'
    | '/_app/brokers/$id'
    | '/_app/brokers/funding'
    | '/_app/brokers/integrations'
    | '/_app/brokers/investigate'
    | '/_app/brokers/lifecycle'
    | '/_app/brokers/payouts'
    | '/_app/brokers/receivables'
    | '/_app/brokers/reconciliation'
    | '/_app/brokers/risk'
    | '/_app/campaigns/$id'
    | '/_app/disputes/$id'
    | '/_app/disputes/alerts'
    | '/_app/disputes/policy'
    | '/_app/leagues/$id'
    | '/_app/me/balance'
    | '/_app/ops/provider'
    | '/_app/orders/history'
    | '/_app/treasury/$id'
    | '/_app/treasury/accounts'
    | '/_app/treasury/fees'
    | '/_app/treasury/payouts'
    | '/_app/treasury/pools'
    | '/_app/treasury/revenue'
    | '/_app/treasury/transfer'
    | '/_app/users/$id'
    | '/_app/wallet-ops/blacklist'
    | '/_app/wallet-ops/collections'
    | '/_app/wallet-ops/custody'
    | '/_app/wallet-ops/deposits'
    | '/_app/wallet-ops/gas'
    | '/_app/wallet-ops/health'
    | '/_app/wallet-ops/liquidity'
    | '/_app/wallet-ops/orders'
    | '/_app/wallet-ops/withdrawals'
    | '/_app/admins/'
    | '/_app/brokers/'
    | '/_app/campaigns/'
    | '/_app/disputes/'
    | '/_app/markets/'
    | '/_app/ops/'
    | '/_app/orders/'
    | '/_app/treasury/'
    | '/_app/wallet-ops/'
    | '/_app/brokers/provider-cases/$caseId'
    | '/_app/brokers/settlement/$brokerId'
    | '/_app/ops/brokers/$brokerId'
    | '/_app/ops/findings/$id'
    | '/_app/ops/runs/$id'
    | '/_app/ops/trades/$tradeId'
    | '/_app/treasury/accounts/$code'
    | '/_app/treasury/fees/activity'
    | '/_app/treasury/fees/redeem'
    | '/_app/treasury/fees/users'
    | '/_app/treasury/revenue/commissions'
    | '/_app/treasury/revenue/distributions'
    | '/_app/treasury/revenue/policies'
    | '/_app/wallet-ops/config/asset-rates'
    | '/_app/wallet-ops/config/assets'
    | '/_app/wallet-ops/config/flags'
    | '/_app/wallet-ops/config/network'
    | '/_app/wallet-ops/config/policies'
    | '/_app/wallet-ops/config/rails'
    | '/_app/brokers/provider-cases/'
    | '/_app/brokers/settlement/'
    | '/_app/ops/brokers/'
    | '/_app/ops/findings/'
    | '/_app/ops/runs/'
    | '/_app/treasury/fees/'
    | '/_app/treasury/revenue/'
    | '/_app/wallet-ops/config/'
    | '/_app/ops/wallets/$walletId/flows'
    | '/_app/treasury/fees/policies/$profileId'
    | '/_app/treasury/fees/policies/new'
    | '/_app/treasury/revenue/events/$eventId'
    | '/_app/treasury/revenue/markets/$marketId'
    | '/_app/wallet-ops/config/policies/collection'
    | '/_app/wallet-ops/config/policies/gas'
    | '/_app/wallet-ops/config/policies/liquidity'
    | '/_app/wallet-ops/config/policies/withdrawal'
    | '/_app/treasury/fees/policies/'
    | '/_app/wallet-ops/config/policies/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/wallet-ops': {
      id: '/_app/wallet-ops'
      path: '/wallet-ops'
      fullPath: '/wallet-ops'
      preLoaderRoute: typeof AppWalletOpsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/treasury': {
      id: '/_app/treasury'
      path: '/treasury'
      fullPath: '/treasury'
      preLoaderRoute: typeof AppTreasuryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trades': {
      id: '/_app/trades'
      path: '/trades'
      fullPath: '/trades'
      preLoaderRoute: typeof AppTradesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/positions': {
      id: '/_app/positions'
      path: '/positions'
      fullPath: '/positions'
      preLoaderRoute: typeof AppPositionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ops': {
      id: '/_app/ops'
      path: '/ops'
      fullPath: '/ops'
      preLoaderRoute: typeof AppOpsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/markets': {
      id: '/_app/markets'
      path: '/markets'
      fullPath: '/markets'
      preLoaderRoute: typeof AppMarketsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leagues': {
      id: '/_app/leagues'
      path: '/leagues'
      fullPath: '/leagues'
      preLoaderRoute: typeof AppLeaguesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/languages': {
      id: '/_app/languages'
      path: '/languages'
      fullPath: '/languages'
      preLoaderRoute: typeof AppLanguagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/global-league': {
      id: '/_app/global-league'
      path: '/global-league'
      fullPath: '/global-league'
      preLoaderRoute: typeof AppGlobalLeagueRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/event-ordering': {
      id: '/_app/event-ordering'
      path: '/event-ordering'
      fullPath: '/event-ordering'
      preLoaderRoute: typeof AppEventOrderingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/engine': {
      id: '/_app/engine'
      path: '/engine'
      fullPath: '/engine'
      preLoaderRoute: typeof AppEngineRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/currencies': {
      id: '/_app/currencies'
      path: '/currencies'
      fullPath: '/currencies'
      preLoaderRoute: typeof AppCurrenciesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ai-consent': {
      id: '/_app/ai-consent'
      path: '/ai-consent'
      fullPath: '/ai-consent'
      preLoaderRoute: typeof AppAiConsentRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admins': {
      id: '/_app/admins'
      path: '/admins'
      fullPath: '/admins'
      preLoaderRoute: typeof AppAdminsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/wallet-ops/': {
      id: '/_app/wallet-ops/'
      path: '/'
      fullPath: '/wallet-ops/'
      preLoaderRoute: typeof AppWalletOpsIndexRouteImport
      parentRoute: typeof AppWalletOpsRoute
    }
    '/_app/treasury/': {
      id: '/_app/treasury/'
      path: '/'
      fullPath: '/treasury/'
      preLoaderRoute: typeof AppTreasuryIndexRouteImport
      parentRoute: typeof AppTreasuryRoute
    }
    '/_app/orders/': {
      id: '/_app/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AppOrdersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ops/': {
      id: '/_app/ops/'
      path: '/'
      fullPath: '/ops/'
      preLoaderRoute: typeof AppOpsIndexRouteImport
      parentRoute: typeof AppOpsRoute
    }
    '/_app/markets/': {
      id: '/_app/markets/'
      path: '/'
      fullPath: '/markets/'
      preLoaderRoute: typeof AppMarketsIndexRouteImport
      parentRoute: typeof AppMarketsRoute
    }
    '/_app/disputes/': {
      id: '/_app/disputes/'
      path: '/disputes'
      fullPath: '/disputes/'
      preLoaderRoute: typeof AppDisputesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/campaigns/': {
      id: '/_app/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof AppCampaignsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brokers/': {
      id: '/_app/brokers/'
      path: '/brokers'
      fullPath: '/brokers/'
      preLoaderRoute: typeof AppBrokersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admins/': {
      id: '/_app/admins/'
      path: '/'
      fullPath: '/admins/'
      preLoaderRoute: typeof AppAdminsIndexRouteImport
      parentRoute: typeof AppAdminsRoute
    }
    '/_app/wallet-ops/withdrawals': {
      id: '/_app/wallet-ops/withdrawals'
      path: '/withdrawals'
      fullPath: '/wallet-ops/withdrawals'
      preLoaderRoute: typeof AppWalletOpsWithdrawalsRouteImport
      parentRoute: typeof AppWalletOpsRoute
    }
    '/_app/wallet-ops/orders': {
      id: '/_app/wallet-ops/orders'
      path: '/orders'
      fullPath: '/wallet-ops/orders'
      preLoaderRoute: typeof AppWalletOpsOrdersRouteImport
      parentRoute: typeof AppWalletOpsRoute
    }
    '/_app/wallet-ops/liquidity': {
      id: '/_app/wallet-ops/liquidity'
      path: '/liquidity'
      fullPath: '/wallet-ops/liquidity'
      preLoaderRoute: typeof AppWalletOpsLiquidityRouteImport
      parentRoute: typeof AppWalletOpsRoute
    }
    '/_app/wallet-ops/health': {
      id: '/_app/wallet-ops/health'
      path: '/health'
      fullPath: '/wallet-ops/health'
      preLoaderRoute: typeof AppWalletOpsHealthRouteImport
      parentRoute: typeof AppWalletOpsRoute
    }
    '/_app/wallet-ops/gas': {
      id: '/_app/wallet-ops/gas'
      path: '/gas'
      fullPath: '/wallet-ops/gas'
      preLoaderRoute: typeof AppWalletOpsGasRouteImport
      parentRoute: typeof AppWalletOpsRoute
    }
    '/_app/wallet-ops/deposits': {
      id: '/_app/wallet-ops/deposits'
      path: '/deposits'
      fullPath: '/wallet-ops/deposits'
      preLoaderRoute: typeof AppWalletOpsDepositsRouteImport
      parentRoute: typeof AppWalletOpsRoute
    }
    '/_app/wallet-ops/custody': {
      id: '/_app/wallet-ops/custody'
      path: '/custody'
      fullPath: '/wallet-ops/custody'
      preLoaderRoute: typeof AppWalletOpsCustodyRouteImport
      parentRoute: typeof AppWalletOpsRoute
    }
    '/_app/wallet-ops/collections': {
      id: '/_app/wallet-ops/collections'
      path: '/collections'
      fullPath: '/wallet-ops/collections'
      preLoaderRoute: typeof AppWalletOpsCollectionsRouteImport
      parentRoute: typeof AppWalletOpsRoute
    }
    '/_app/wallet-ops/blacklist': {
      id: '/_app/wallet-ops/blacklist'
      path: '/blacklist'
      fullPath: '/wallet-ops/blacklist'
      preLoaderRoute: typeof AppWalletOpsBlacklistRouteImport
      parentRoute: typeof AppWalletOpsRoute
    }
    '/_app/users/$id': {
      id: '/_app/users/$id'
      path: '/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AppUsersIdRouteImport
      parentRoute: typeof AppUsersRoute
    }
    '/_app/treasury/transfer': {
      id: '/_app/treasury/transfer'
      path: '/transfer'
      fullPath: '/treasury/transfer'
      preLoaderRoute: typeof AppTreasuryTransferRouteImport
      parentRoute: typeof AppTreasuryRoute
    }
    '/_app/treasury/revenue': {
      id: '/_app/treasury/revenue'
      path: '/revenue'
      fullPath: '/treasury/revenue'
      preLoaderRoute: typeof AppTreasuryRevenueRouteImport
      parentRoute: typeof AppTreasuryRoute
    }
    '/_app/treasury/pools': {
      id: '/_app/treasury/pools'
      path: '/pools'
      fullPath: '/treasury/pools'
      preLoaderRoute: typeof AppTreasuryPoolsRouteImport
      parentRoute: typeof AppTreasuryRoute
    }
    '/_app/treasury/payouts': {
      id: '/_app/treasury/payouts'
      path: '/payouts'
      fullPath: '/treasury/payouts'
      preLoaderRoute: typeof AppTreasuryPayoutsRouteImport
      parentRoute: typeof AppTreasuryRoute
    }
    '/_app/treasury/fees': {
      id: '/_app/treasury/fees'
      path: '/fees'
      fullPath: '/treasury/fees'
      preLoaderRoute: typeof AppTreasuryFeesRouteImport
      parentRoute: typeof AppTreasuryRoute
    }
    '/_app/treasury/accounts': {
      id: '/_app/treasury/accounts'
      path: '/accounts'
      fullPath: '/treasury/accounts'
      preLoaderRoute: typeof AppTreasuryAccountsRouteImport
      parentRoute: typeof AppTreasuryRoute
    }
    '/_app/treasury/$id': {
      id: '/_app/treasury/$id'
      path: '/$id'
      fullPath: '/treasury/$id'
      preLoaderRoute: typeof AppTreasuryIdRouteImport
      parentRoute: typeof AppTreasuryRoute
    }
    '/_app/orders/history': {
      id: '/_app/orders/history'
      path: '/orders/history'
      fullPath: '/orders/history'
      preLoaderRoute: typeof AppOrdersHistoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ops/provider': {
      id: '/_app/ops/provider'
      path: '/provider'
      fullPath: '/ops/provider'
      preLoaderRoute: typeof AppOpsProviderRouteImport
      parentRoute: typeof AppOpsRoute
    }
    '/_app/me/balance': {
      id: '/_app/me/balance'
      path: '/me/balance'
      fullPath: '/me/balance'
      preLoaderRoute: typeof AppMeBalanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leagues/$id': {
      id: '/_app/leagues/$id'
      path: '/$id'
      fullPath: '/leagues/$id'
      preLoaderRoute: typeof AppLeaguesIdRouteImport
      parentRoute: typeof AppLeaguesRoute
    }
    '/_app/disputes/policy': {
      id: '/_app/disputes/policy'
      path: '/disputes/policy'
      fullPath: '/disputes/policy'
      preLoaderRoute: typeof AppDisputesPolicyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/disputes/alerts': {
      id: '/_app/disputes/alerts'
      path: '/disputes/alerts'
      fullPath: '/disputes/alerts'
      preLoaderRoute: typeof AppDisputesAlertsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/disputes/$id': {
      id: '/_app/disputes/$id'
      path: '/disputes/$id'
      fullPath: '/disputes/$id'
      preLoaderRoute: typeof AppDisputesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/campaigns/$id': {
      id: '/_app/campaigns/$id'
      path: '/campaigns/$id'
      fullPath: '/campaigns/$id'
      preLoaderRoute: typeof AppCampaignsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brokers/risk': {
      id: '/_app/brokers/risk'
      path: '/brokers/risk'
      fullPath: '/brokers/risk'
      preLoaderRoute: typeof AppBrokersRiskRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brokers/reconciliation': {
      id: '/_app/brokers/reconciliation'
      path: '/brokers/reconciliation'
      fullPath: '/brokers/reconciliation'
      preLoaderRoute: typeof AppBrokersReconciliationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brokers/receivables': {
      id: '/_app/brokers/receivables'
      path: '/brokers/receivables'
      fullPath: '/brokers/receivables'
      preLoaderRoute: typeof AppBrokersReceivablesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brokers/payouts': {
      id: '/_app/brokers/payouts'
      path: '/brokers/payouts'
      fullPath: '/brokers/payouts'
      preLoaderRoute: typeof AppBrokersPayoutsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brokers/lifecycle': {
      id: '/_app/brokers/lifecycle'
      path: '/brokers/lifecycle'
      fullPath: '/brokers/lifecycle'
      preLoaderRoute: typeof AppBrokersLifecycleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brokers/investigate': {
      id: '/_app/brokers/investigate'
      path: '/brokers/investigate'
      fullPath: '/brokers/investigate'
      preLoaderRoute: typeof AppBrokersInvestigateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brokers/integrations': {
      id: '/_app/brokers/integrations'
      path: '/brokers/integrations'
      fullPath: '/brokers/integrations'
      preLoaderRoute: typeof AppBrokersIntegrationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brokers/funding': {
      id: '/_app/brokers/funding'
      path: '/brokers/funding'
      fullPath: '/brokers/funding'
      preLoaderRoute: typeof AppBrokersFundingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brokers/$id': {
      id: '/_app/brokers/$id'
      path: '/brokers/$id'
      fullPath: '/brokers/$id'
      preLoaderRoute: typeof AppBrokersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ai/usage': {
      id: '/_app/ai/usage'
      path: '/ai/usage'
      fullPath: '/ai/usage'
      preLoaderRoute: typeof AppAiUsageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ai/policy': {
      id: '/_app/ai/policy'
      path: '/ai/policy'
      fullPath: '/ai/policy'
      preLoaderRoute: typeof AppAiPolicyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ai/connections': {
      id: '/_app/ai/connections'
      path: '/ai/connections'
      fullPath: '/ai/connections'
      preLoaderRoute: typeof AppAiConnectionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ai/approvals': {
      id: '/_app/ai/approvals'
      path: '/ai/approvals'
      fullPath: '/ai/approvals'
      preLoaderRoute: typeof AppAiApprovalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admins/roles': {
      id: '/_app/admins/roles'
      path: '/roles'
      fullPath: '/admins/roles'
      preLoaderRoute: typeof AppAdminsRolesRouteImport
      parentRoute: typeof AppAdminsRoute
    }
    '/_app/admins/$id': {
      id: '/_app/admins/$id'
      path: '/$id'
      fullPath: '/admins/$id'
      preLoaderRoute: typeof AppAdminsIdRouteImport
      parentRoute: typeof AppAdminsRoute
    }
    '/_app/wallet-ops/config/': {
      id: '/_app/wallet-ops/config/'
      path: '/config'
      fullPath: '/wallet-ops/config/'
      preLoaderRoute: typeof AppWalletOpsConfigIndexRouteImport
      parentRoute: typeof AppWalletOpsRoute
    }
    '/_app/treasury/revenue/': {
      id: '/_app/treasury/revenue/'
      path: '/'
      fullPath: '/treasury/revenue/'
      preLoaderRoute: typeof AppTreasuryRevenueIndexRouteImport
      parentRoute: typeof AppTreasuryRevenueRoute
    }
    '/_app/treasury/fees/': {
      id: '/_app/treasury/fees/'
      path: '/'
      fullPath: '/treasury/fees/'
      preLoaderRoute: typeof AppTreasuryFeesIndexRouteImport
      parentRoute: typeof AppTreasuryFeesRoute
    }
    '/_app/ops/runs/': {
      id: '/_app/ops/runs/'
      path: '/runs'
      fullPath: '/ops/runs/'
      preLoaderRoute: typeof AppOpsRunsIndexRouteImport
      parentRoute: typeof AppOpsRoute
    }
    '/_app/ops/findings/': {
      id: '/_app/ops/findings/'
      path: '/findings'
      fullPath: '/ops/findings/'
      preLoaderRoute: typeof AppOpsFindingsIndexRouteImport
      parentRoute: typeof AppOpsRoute
    }
    '/_app/ops/brokers/': {
      id: '/_app/ops/brokers/'
      path: '/brokers'
      fullPath: '/ops/brokers/'
      preLoaderRoute: typeof AppOpsBrokersIndexRouteImport
      parentRoute: typeof AppOpsRoute
    }
    '/_app/brokers/settlement/': {
      id: '/_app/brokers/settlement/'
      path: '/brokers/settlement'
      fullPath: '/brokers/settlement/'
      preLoaderRoute: typeof AppBrokersSettlementIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brokers/provider-cases/': {
      id: '/_app/brokers/provider-cases/'
      path: '/brokers/provider-cases'
      fullPath: '/brokers/provider-cases/'
      preLoaderRoute: typeof AppBrokersProviderCasesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/wallet-ops/config/rails': {
      id: '/_app/wallet-ops/config/rails'
      path: '/config/rails'
      fullPath: '/wallet-ops/config/rails'
      preLoaderRoute: typeof AppWalletOpsConfigRailsRouteImport
      parentRoute: typeof AppWalletOpsRoute
    }
    '/_app/wallet-ops/config/policies': {
      id: '/_app/wallet-ops/config/policies'
      path: '/config/policies'
      fullPath: '/wallet-ops/config/policies'
      preLoaderRoute: typeof AppWalletOpsConfigPoliciesRouteImport
      parentRoute: typeof AppWalletOpsRoute
    }
    '/_app/wallet-ops/config/network': {
      id: '/_app/wallet-ops/config/network'
      path: '/config/network'
      fullPath: '/wallet-ops/config/network'
      preLoaderRoute: typeof AppWalletOpsConfigNetworkRouteImport
      parentRoute: typeof AppWalletOpsRoute
    }
    '/_app/wallet-ops/config/flags': {
      id: '/_app/wallet-ops/config/flags'
      path: '/config/flags'
      fullPath: '/wallet-ops/config/flags'
      preLoaderRoute: typeof AppWalletOpsConfigFlagsRouteImport
      parentRoute: typeof AppWalletOpsRoute
    }
    '/_app/wallet-ops/config/assets': {
      id: '/_app/wallet-ops/config/assets'
      path: '/config/assets'
      fullPath: '/wallet-ops/config/assets'
      preLoaderRoute: typeof AppWalletOpsConfigAssetsRouteImport
      parentRoute: typeof AppWalletOpsRoute
    }
    '/_app/wallet-ops/config/asset-rates': {
      id: '/_app/wallet-ops/config/asset-rates'
      path: '/config/asset-rates'
      fullPath: '/wallet-ops/config/asset-rates'
      preLoaderRoute: typeof AppWalletOpsConfigAssetRatesRouteImport
      parentRoute: typeof AppWalletOpsRoute
    }
    '/_app/treasury/revenue/policies': {
      id: '/_app/treasury/revenue/policies'
      path: '/policies'
      fullPath: '/treasury/revenue/policies'
      preLoaderRoute: typeof AppTreasuryRevenuePoliciesRouteImport
      parentRoute: typeof AppTreasuryRevenueRoute
    }
    '/_app/treasury/revenue/distributions': {
      id: '/_app/treasury/revenue/distributions'
      path: '/distributions'
      fullPath: '/treasury/revenue/distributions'
      preLoaderRoute: typeof AppTreasuryRevenueDistributionsRouteImport
      parentRoute: typeof AppTreasuryRevenueRoute
    }
    '/_app/treasury/revenue/commissions': {
      id: '/_app/treasury/revenue/commissions'
      path: '/commissions'
      fullPath: '/treasury/revenue/commissions'
      preLoaderRoute: typeof AppTreasuryRevenueCommissionsRouteImport
      parentRoute: typeof AppTreasuryRevenueRoute
    }
    '/_app/treasury/fees/users': {
      id: '/_app/treasury/fees/users'
      path: '/users'
      fullPath: '/treasury/fees/users'
      preLoaderRoute: typeof AppTreasuryFeesUsersRouteImport
      parentRoute: typeof AppTreasuryFeesRoute
    }
    '/_app/treasury/fees/redeem': {
      id: '/_app/treasury/fees/redeem'
      path: '/redeem'
      fullPath: '/treasury/fees/redeem'
      preLoaderRoute: typeof AppTreasuryFeesRedeemRouteImport
      parentRoute: typeof AppTreasuryFeesRoute
    }
    '/_app/treasury/fees/activity': {
      id: '/_app/treasury/fees/activity'
      path: '/activity'
      fullPath: '/treasury/fees/activity'
      preLoaderRoute: typeof AppTreasuryFeesActivityRouteImport
      parentRoute: typeof AppTreasuryFeesRoute
    }
    '/_app/treasury/accounts/$code': {
      id: '/_app/treasury/accounts/$code'
      path: '/$code'
      fullPath: '/treasury/accounts/$code'
      preLoaderRoute: typeof AppTreasuryAccountsCodeRouteImport
      parentRoute: typeof AppTreasuryAccountsRoute
    }
    '/_app/ops/trades/$tradeId': {
      id: '/_app/ops/trades/$tradeId'
      path: '/trades/$tradeId'
      fullPath: '/ops/trades/$tradeId'
      preLoaderRoute: typeof AppOpsTradesTradeIdRouteImport
      parentRoute: typeof AppOpsRoute
    }
    '/_app/ops/runs/$id': {
      id: '/_app/ops/runs/$id'
      path: '/runs/$id'
      fullPath: '/ops/runs/$id'
      preLoaderRoute: typeof AppOpsRunsIdRouteImport
      parentRoute: typeof AppOpsRoute
    }
    '/_app/ops/findings/$id': {
      id: '/_app/ops/findings/$id'
      path: '/findings/$id'
      fullPath: '/ops/findings/$id'
      preLoaderRoute: typeof AppOpsFindingsIdRouteImport
      parentRoute: typeof AppOpsRoute
    }
    '/_app/ops/brokers/$brokerId': {
      id: '/_app/ops/brokers/$brokerId'
      path: '/brokers/$brokerId'
      fullPath: '/ops/brokers/$brokerId'
      preLoaderRoute: typeof AppOpsBrokersBrokerIdRouteImport
      parentRoute: typeof AppOpsRoute
    }
    '/_app/brokers/settlement/$brokerId': {
      id: '/_app/brokers/settlement/$brokerId'
      path: '/brokers/settlement/$brokerId'
      fullPath: '/brokers/settlement/$brokerId'
      preLoaderRoute: typeof AppBrokersSettlementBrokerIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/brokers/provider-cases/$caseId': {
      id: '/_app/brokers/provider-cases/$caseId'
      path: '/brokers/provider-cases/$caseId'
      fullPath: '/brokers/provider-cases/$caseId'
      preLoaderRoute: typeof AppBrokersProviderCasesCaseIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/wallet-ops/config/policies/': {
      id: '/_app/wallet-ops/config/policies/'
      path: '/'
      fullPath: '/wallet-ops/config/policies/'
      preLoaderRoute: typeof AppWalletOpsConfigPoliciesIndexRouteImport
      parentRoute: typeof AppWalletOpsConfigPoliciesRoute
    }
    '/_app/treasury/fees/policies/': {
      id: '/_app/treasury/fees/policies/'
      path: '/policies'
      fullPath: '/treasury/fees/policies/'
      preLoaderRoute: typeof AppTreasuryFeesPoliciesIndexRouteImport
      parentRoute: typeof AppTreasuryFeesRoute
    }
    '/_app/wallet-ops/config/policies/withdrawal': {
      id: '/_app/wallet-ops/config/policies/withdrawal'
      path: '/withdrawal'
      fullPath: '/wallet-ops/config/policies/withdrawal'
      preLoaderRoute: typeof AppWalletOpsConfigPoliciesWithdrawalRouteImport
      parentRoute: typeof AppWalletOpsConfigPoliciesRoute
    }
    '/_app/wallet-ops/config/policies/liquidity': {
      id: '/_app/wallet-ops/config/policies/liquidity'
      path: '/liquidity'
      fullPath: '/wallet-ops/config/policies/liquidity'
      preLoaderRoute: typeof AppWalletOpsConfigPoliciesLiquidityRouteImport
      parentRoute: typeof AppWalletOpsConfigPoliciesRoute
    }
    '/_app/wallet-ops/config/policies/gas': {
      id: '/_app/wallet-ops/config/policies/gas'
      path: '/gas'
      fullPath: '/wallet-ops/config/policies/gas'
      preLoaderRoute: typeof AppWalletOpsConfigPoliciesGasRouteImport
      parentRoute: typeof AppWalletOpsConfigPoliciesRoute
    }
    '/_app/wallet-ops/config/policies/collection': {
      id: '/_app/wallet-ops/config/policies/collection'
      path: '/collection'
      fullPath: '/wallet-ops/config/policies/collection'
      preLoaderRoute: typeof AppWalletOpsConfigPoliciesCollectionRouteImport
      parentRoute: typeof AppWalletOpsConfigPoliciesRoute
    }
    '/_app/treasury/revenue/markets/$marketId': {
      id: '/_app/treasury/revenue/markets/$marketId'
      path: '/markets/$marketId'
      fullPath: '/treasury/revenue/markets/$marketId'
      preLoaderRoute: typeof AppTreasuryRevenueMarketsMarketIdRouteImport
      parentRoute: typeof AppTreasuryRevenueRoute
    }
    '/_app/treasury/revenue/events/$eventId': {
      id: '/_app/treasury/revenue/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/treasury/revenue/events/$eventId'
      preLoaderRoute: typeof AppTreasuryRevenueEventsEventIdRouteImport
      parentRoute: typeof AppTreasuryRevenueRoute
    }
    '/_app/treasury/fees/policies/new': {
      id: '/_app/treasury/fees/policies/new'
      path: '/policies/new'
      fullPath: '/treasury/fees/policies/new'
      preLoaderRoute: typeof AppTreasuryFeesPoliciesNewRouteImport
      parentRoute: typeof AppTreasuryFeesRoute
    }
    '/_app/treasury/fees/policies/$profileId': {
      id: '/_app/treasury/fees/policies/$profileId'
      path: '/policies/$profileId'
      fullPath: '/treasury/fees/policies/$profileId'
      preLoaderRoute: typeof AppTreasuryFeesPoliciesProfileIdRouteImport
      parentRoute: typeof AppTreasuryFeesRoute
    }
    '/_app/ops/wallets/$walletId/flows': {
      id: '/_app/ops/wallets/$walletId/flows'
      path: '/wallets/$walletId/flows'
      fullPath: '/ops/wallets/$walletId/flows'
      preLoaderRoute: typeof AppOpsWalletsWalletIdFlowsRouteImport
      parentRoute: typeof AppOpsRoute
    }
  }
}

interface AppAdminsRouteChildren {
  AppAdminsIdRoute: typeof AppAdminsIdRoute
  AppAdminsRolesRoute: typeof AppAdminsRolesRoute
  AppAdminsIndexRoute: typeof AppAdminsIndexRoute
}

const AppAdminsRouteChildren: AppAdminsRouteChildren = {
  AppAdminsIdRoute: AppAdminsIdRoute,
  AppAdminsRolesRoute: AppAdminsRolesRoute,
  AppAdminsIndexRoute: AppAdminsIndexRoute,
}

const AppAdminsRouteWithChildren = AppAdminsRoute._addFileChildren(
  AppAdminsRouteChildren,
)

interface AppLeaguesRouteChildren {
  AppLeaguesIdRoute: typeof AppLeaguesIdRoute
}

const AppLeaguesRouteChildren: AppLeaguesRouteChildren = {
  AppLeaguesIdRoute: AppLeaguesIdRoute,
}

const AppLeaguesRouteWithChildren = AppLeaguesRoute._addFileChildren(
  AppLeaguesRouteChildren,
)

interface AppMarketsRouteChildren {
  AppMarketsIndexRoute: typeof AppMarketsIndexRoute
}

const AppMarketsRouteChildren: AppMarketsRouteChildren = {
  AppMarketsIndexRoute: AppMarketsIndexRoute,
}

const AppMarketsRouteWithChildren = AppMarketsRoute._addFileChildren(
  AppMarketsRouteChildren,
)

interface AppOpsRouteChildren {
  AppOpsProviderRoute: typeof AppOpsProviderRoute
  AppOpsIndexRoute: typeof AppOpsIndexRoute
  AppOpsBrokersBrokerIdRoute: typeof AppOpsBrokersBrokerIdRoute
  AppOpsFindingsIdRoute: typeof AppOpsFindingsIdRoute
  AppOpsRunsIdRoute: typeof AppOpsRunsIdRoute
  AppOpsTradesTradeIdRoute: typeof AppOpsTradesTradeIdRoute
  AppOpsBrokersIndexRoute: typeof AppOpsBrokersIndexRoute
  AppOpsFindingsIndexRoute: typeof AppOpsFindingsIndexRoute
  AppOpsRunsIndexRoute: typeof AppOpsRunsIndexRoute
  AppOpsWalletsWalletIdFlowsRoute: typeof AppOpsWalletsWalletIdFlowsRoute
}

const AppOpsRouteChildren: AppOpsRouteChildren = {
  AppOpsProviderRoute: AppOpsProviderRoute,
  AppOpsIndexRoute: AppOpsIndexRoute,
  AppOpsBrokersBrokerIdRoute: AppOpsBrokersBrokerIdRoute,
  AppOpsFindingsIdRoute: AppOpsFindingsIdRoute,
  AppOpsRunsIdRoute: AppOpsRunsIdRoute,
  AppOpsTradesTradeIdRoute: AppOpsTradesTradeIdRoute,
  AppOpsBrokersIndexRoute: AppOpsBrokersIndexRoute,
  AppOpsFindingsIndexRoute: AppOpsFindingsIndexRoute,
  AppOpsRunsIndexRoute: AppOpsRunsIndexRoute,
  AppOpsWalletsWalletIdFlowsRoute: AppOpsWalletsWalletIdFlowsRoute,
}

const AppOpsRouteWithChildren =
  AppOpsRoute._addFileChildren(AppOpsRouteChildren)

interface AppTreasuryAccountsRouteChildren {
  AppTreasuryAccountsCodeRoute: typeof AppTreasuryAccountsCodeRoute
}

const AppTreasuryAccountsRouteChildren: AppTreasuryAccountsRouteChildren = {
  AppTreasuryAccountsCodeRoute: AppTreasuryAccountsCodeRoute,
}

const AppTreasuryAccountsRouteWithChildren =
  AppTreasuryAccountsRoute._addFileChildren(AppTreasuryAccountsRouteChildren)

interface AppTreasuryFeesRouteChildren {
  AppTreasuryFeesActivityRoute: typeof AppTreasuryFeesActivityRoute
  AppTreasuryFeesRedeemRoute: typeof AppTreasuryFeesRedeemRoute
  AppTreasuryFeesUsersRoute: typeof AppTreasuryFeesUsersRoute
  AppTreasuryFeesIndexRoute: typeof AppTreasuryFeesIndexRoute
  AppTreasuryFeesPoliciesProfileIdRoute: typeof AppTreasuryFeesPoliciesProfileIdRoute
  AppTreasuryFeesPoliciesNewRoute: typeof AppTreasuryFeesPoliciesNewRoute
  AppTreasuryFeesPoliciesIndexRoute: typeof AppTreasuryFeesPoliciesIndexRoute
}

const AppTreasuryFeesRouteChildren: AppTreasuryFeesRouteChildren = {
  AppTreasuryFeesActivityRoute: AppTreasuryFeesActivityRoute,
  AppTreasuryFeesRedeemRoute: AppTreasuryFeesRedeemRoute,
  AppTreasuryFeesUsersRoute: AppTreasuryFeesUsersRoute,
  AppTreasuryFeesIndexRoute: AppTreasuryFeesIndexRoute,
  AppTreasuryFeesPoliciesProfileIdRoute: AppTreasuryFeesPoliciesProfileIdRoute,
  AppTreasuryFeesPoliciesNewRoute: AppTreasuryFeesPoliciesNewRoute,
  AppTreasuryFeesPoliciesIndexRoute: AppTreasuryFeesPoliciesIndexRoute,
}

const AppTreasuryFeesRouteWithChildren = AppTreasuryFeesRoute._addFileChildren(
  AppTreasuryFeesRouteChildren,
)

interface AppTreasuryRevenueRouteChildren {
  AppTreasuryRevenueCommissionsRoute: typeof AppTreasuryRevenueCommissionsRoute
  AppTreasuryRevenueDistributionsRoute: typeof AppTreasuryRevenueDistributionsRoute
  AppTreasuryRevenuePoliciesRoute: typeof AppTreasuryRevenuePoliciesRoute
  AppTreasuryRevenueIndexRoute: typeof AppTreasuryRevenueIndexRoute
  AppTreasuryRevenueEventsEventIdRoute: typeof AppTreasuryRevenueEventsEventIdRoute
  AppTreasuryRevenueMarketsMarketIdRoute: typeof AppTreasuryRevenueMarketsMarketIdRoute
}

const AppTreasuryRevenueRouteChildren: AppTreasuryRevenueRouteChildren = {
  AppTreasuryRevenueCommissionsRoute: AppTreasuryRevenueCommissionsRoute,
  AppTreasuryRevenueDistributionsRoute: AppTreasuryRevenueDistributionsRoute,
  AppTreasuryRevenuePoliciesRoute: AppTreasuryRevenuePoliciesRoute,
  AppTreasuryRevenueIndexRoute: AppTreasuryRevenueIndexRoute,
  AppTreasuryRevenueEventsEventIdRoute: AppTreasuryRevenueEventsEventIdRoute,
  AppTreasuryRevenueMarketsMarketIdRoute:
    AppTreasuryRevenueMarketsMarketIdRoute,
}

const AppTreasuryRevenueRouteWithChildren =
  AppTreasuryRevenueRoute._addFileChildren(AppTreasuryRevenueRouteChildren)

interface AppTreasuryRouteChildren {
  AppTreasuryIdRoute: typeof AppTreasuryIdRoute
  AppTreasuryAccountsRoute: typeof AppTreasuryAccountsRouteWithChildren
  AppTreasuryFeesRoute: typeof AppTreasuryFeesRouteWithChildren
  AppTreasuryPayoutsRoute: typeof AppTreasuryPayoutsRoute
  AppTreasuryPoolsRoute: typeof AppTreasuryPoolsRoute
  AppTreasuryRevenueRoute: typeof AppTreasuryRevenueRouteWithChildren
  AppTreasuryTransferRoute: typeof AppTreasuryTransferRoute
  AppTreasuryIndexRoute: typeof AppTreasuryIndexRoute
}

const AppTreasuryRouteChildren: AppTreasuryRouteChildren = {
  AppTreasuryIdRoute: AppTreasuryIdRoute,
  AppTreasuryAccountsRoute: AppTreasuryAccountsRouteWithChildren,
  AppTreasuryFeesRoute: AppTreasuryFeesRouteWithChildren,
  AppTreasuryPayoutsRoute: AppTreasuryPayoutsRoute,
  AppTreasuryPoolsRoute: AppTreasuryPoolsRoute,
  AppTreasuryRevenueRoute: AppTreasuryRevenueRouteWithChildren,
  AppTreasuryTransferRoute: AppTreasuryTransferRoute,
  AppTreasuryIndexRoute: AppTreasuryIndexRoute,
}

const AppTreasuryRouteWithChildren = AppTreasuryRoute._addFileChildren(
  AppTreasuryRouteChildren,
)

interface AppUsersRouteChildren {
  AppUsersIdRoute: typeof AppUsersIdRoute
}

const AppUsersRouteChildren: AppUsersRouteChildren = {
  AppUsersIdRoute: AppUsersIdRoute,
}

const AppUsersRouteWithChildren = AppUsersRoute._addFileChildren(
  AppUsersRouteChildren,
)

interface AppWalletOpsConfigPoliciesRouteChildren {
  AppWalletOpsConfigPoliciesCollectionRoute: typeof AppWalletOpsConfigPoliciesCollectionRoute
  AppWalletOpsConfigPoliciesGasRoute: typeof AppWalletOpsConfigPoliciesGasRoute
  AppWalletOpsConfigPoliciesLiquidityRoute: typeof AppWalletOpsConfigPoliciesLiquidityRoute
  AppWalletOpsConfigPoliciesWithdrawalRoute: typeof AppWalletOpsConfigPoliciesWithdrawalRoute
  AppWalletOpsConfigPoliciesIndexRoute: typeof AppWalletOpsConfigPoliciesIndexRoute
}

const AppWalletOpsConfigPoliciesRouteChildren: AppWalletOpsConfigPoliciesRouteChildren =
  {
    AppWalletOpsConfigPoliciesCollectionRoute:
      AppWalletOpsConfigPoliciesCollectionRoute,
    AppWalletOpsConfigPoliciesGasRoute: AppWalletOpsConfigPoliciesGasRoute,
    AppWalletOpsConfigPoliciesLiquidityRoute:
      AppWalletOpsConfigPoliciesLiquidityRoute,
    AppWalletOpsConfigPoliciesWithdrawalRoute:
      AppWalletOpsConfigPoliciesWithdrawalRoute,
    AppWalletOpsConfigPoliciesIndexRoute: AppWalletOpsConfigPoliciesIndexRoute,
  }

const AppWalletOpsConfigPoliciesRouteWithChildren =
  AppWalletOpsConfigPoliciesRoute._addFileChildren(
    AppWalletOpsConfigPoliciesRouteChildren,
  )

interface AppWalletOpsRouteChildren {
  AppWalletOpsBlacklistRoute: typeof AppWalletOpsBlacklistRoute
  AppWalletOpsCollectionsRoute: typeof AppWalletOpsCollectionsRoute
  AppWalletOpsCustodyRoute: typeof AppWalletOpsCustodyRoute
  AppWalletOpsDepositsRoute: typeof AppWalletOpsDepositsRoute
  AppWalletOpsGasRoute: typeof AppWalletOpsGasRoute
  AppWalletOpsHealthRoute: typeof AppWalletOpsHealthRoute
  AppWalletOpsLiquidityRoute: typeof AppWalletOpsLiquidityRoute
  AppWalletOpsOrdersRoute: typeof AppWalletOpsOrdersRoute
  AppWalletOpsWithdrawalsRoute: typeof AppWalletOpsWithdrawalsRoute
  AppWalletOpsIndexRoute: typeof AppWalletOpsIndexRoute
  AppWalletOpsConfigAssetRatesRoute: typeof AppWalletOpsConfigAssetRatesRoute
  AppWalletOpsConfigAssetsRoute: typeof AppWalletOpsConfigAssetsRoute
  AppWalletOpsConfigFlagsRoute: typeof AppWalletOpsConfigFlagsRoute
  AppWalletOpsConfigNetworkRoute: typeof AppWalletOpsConfigNetworkRoute
  AppWalletOpsConfigPoliciesRoute: typeof AppWalletOpsConfigPoliciesRouteWithChildren
  AppWalletOpsConfigRailsRoute: typeof AppWalletOpsConfigRailsRoute
  AppWalletOpsConfigIndexRoute: typeof AppWalletOpsConfigIndexRoute
}

const AppWalletOpsRouteChildren: AppWalletOpsRouteChildren = {
  AppWalletOpsBlacklistRoute: AppWalletOpsBlacklistRoute,
  AppWalletOpsCollectionsRoute: AppWalletOpsCollectionsRoute,
  AppWalletOpsCustodyRoute: AppWalletOpsCustodyRoute,
  AppWalletOpsDepositsRoute: AppWalletOpsDepositsRoute,
  AppWalletOpsGasRoute: AppWalletOpsGasRoute,
  AppWalletOpsHealthRoute: AppWalletOpsHealthRoute,
  AppWalletOpsLiquidityRoute: AppWalletOpsLiquidityRoute,
  AppWalletOpsOrdersRoute: AppWalletOpsOrdersRoute,
  AppWalletOpsWithdrawalsRoute: AppWalletOpsWithdrawalsRoute,
  AppWalletOpsIndexRoute: AppWalletOpsIndexRoute,
  AppWalletOpsConfigAssetRatesRoute: AppWalletOpsConfigAssetRatesRoute,
  AppWalletOpsConfigAssetsRoute: AppWalletOpsConfigAssetsRoute,
  AppWalletOpsConfigFlagsRoute: AppWalletOpsConfigFlagsRoute,
  AppWalletOpsConfigNetworkRoute: AppWalletOpsConfigNetworkRoute,
  AppWalletOpsConfigPoliciesRoute: AppWalletOpsConfigPoliciesRouteWithChildren,
  AppWalletOpsConfigRailsRoute: AppWalletOpsConfigRailsRoute,
  AppWalletOpsConfigIndexRoute: AppWalletOpsConfigIndexRoute,
}

const AppWalletOpsRouteWithChildren = AppWalletOpsRoute._addFileChildren(
  AppWalletOpsRouteChildren,
)

interface AppRouteChildren {
  AppAdminsRoute: typeof AppAdminsRouteWithChildren
  AppAiConsentRoute: typeof AppAiConsentRoute
  AppAuditRoute: typeof AppAuditRoute
  AppCurrenciesRoute: typeof AppCurrenciesRoute
  AppEngineRoute: typeof AppEngineRoute
  AppEventOrderingRoute: typeof AppEventOrderingRoute
  AppGlobalLeagueRoute: typeof AppGlobalLeagueRoute
  AppLanguagesRoute: typeof AppLanguagesRoute
  AppLeaguesRoute: typeof AppLeaguesRouteWithChildren
  AppMarketsRoute: typeof AppMarketsRouteWithChildren
  AppOpsRoute: typeof AppOpsRouteWithChildren
  AppPositionsRoute: typeof AppPositionsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTradesRoute: typeof AppTradesRoute
  AppTreasuryRoute: typeof AppTreasuryRouteWithChildren
  AppUsersRoute: typeof AppUsersRouteWithChildren
  AppWalletOpsRoute: typeof AppWalletOpsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppAiApprovalsRoute: typeof AppAiApprovalsRoute
  AppAiConnectionsRoute: typeof AppAiConnectionsRoute
  AppAiPolicyRoute: typeof AppAiPolicyRoute
  AppAiUsageRoute: typeof AppAiUsageRoute
  AppBrokersIdRoute: typeof AppBrokersIdRoute
  AppBrokersFundingRoute: typeof AppBrokersFundingRoute
  AppBrokersIntegrationsRoute: typeof AppBrokersIntegrationsRoute
  AppBrokersInvestigateRoute: typeof AppBrokersInvestigateRoute
  AppBrokersLifecycleRoute: typeof AppBrokersLifecycleRoute
  AppBrokersPayoutsRoute: typeof AppBrokersPayoutsRoute
  AppBrokersReceivablesRoute: typeof AppBrokersReceivablesRoute
  AppBrokersReconciliationRoute: typeof AppBrokersReconciliationRoute
  AppBrokersRiskRoute: typeof AppBrokersRiskRoute
  AppCampaignsIdRoute: typeof AppCampaignsIdRoute
  AppDisputesIdRoute: typeof AppDisputesIdRoute
  AppDisputesAlertsRoute: typeof AppDisputesAlertsRoute
  AppDisputesPolicyRoute: typeof AppDisputesPolicyRoute
  AppMeBalanceRoute: typeof AppMeBalanceRoute
  AppOrdersHistoryRoute: typeof AppOrdersHistoryRoute
  AppBrokersIndexRoute: typeof AppBrokersIndexRoute
  AppCampaignsIndexRoute: typeof AppCampaignsIndexRoute
  AppDisputesIndexRoute: typeof AppDisputesIndexRoute
  AppOrdersIndexRoute: typeof AppOrdersIndexRoute
  AppBrokersProviderCasesCaseIdRoute: typeof AppBrokersProviderCasesCaseIdRoute
  AppBrokersSettlementBrokerIdRoute: typeof AppBrokersSettlementBrokerIdRoute
  AppBrokersProviderCasesIndexRoute: typeof AppBrokersProviderCasesIndexRoute
  AppBrokersSettlementIndexRoute: typeof AppBrokersSettlementIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminsRoute: AppAdminsRouteWithChildren,
  AppAiConsentRoute: AppAiConsentRoute,
  AppAuditRoute: AppAuditRoute,
  AppCurrenciesRoute: AppCurrenciesRoute,
  AppEngineRoute: AppEngineRoute,
  AppEventOrderingRoute: AppEventOrderingRoute,
  AppGlobalLeagueRoute: AppGlobalLeagueRoute,
  AppLanguagesRoute: AppLanguagesRoute,
  AppLeaguesRoute: AppLeaguesRouteWithChildren,
  AppMarketsRoute: AppMarketsRouteWithChildren,
  AppOpsRoute: AppOpsRouteWithChildren,
  AppPositionsRoute: AppPositionsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTradesRoute: AppTradesRoute,
  AppTreasuryRoute: AppTreasuryRouteWithChildren,
  AppUsersRoute: AppUsersRouteWithChildren,
  AppWalletOpsRoute: AppWalletOpsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppAiApprovalsRoute: AppAiApprovalsRoute,
  AppAiConnectionsRoute: AppAiConnectionsRoute,
  AppAiPolicyRoute: AppAiPolicyRoute,
  AppAiUsageRoute: AppAiUsageRoute,
  AppBrokersIdRoute: AppBrokersIdRoute,
  AppBrokersFundingRoute: AppBrokersFundingRoute,
  AppBrokersIntegrationsRoute: AppBrokersIntegrationsRoute,
  AppBrokersInvestigateRoute: AppBrokersInvestigateRoute,
  AppBrokersLifecycleRoute: AppBrokersLifecycleRoute,
  AppBrokersPayoutsRoute: AppBrokersPayoutsRoute,
  AppBrokersReceivablesRoute: AppBrokersReceivablesRoute,
  AppBrokersReconciliationRoute: AppBrokersReconciliationRoute,
  AppBrokersRiskRoute: AppBrokersRiskRoute,
  AppCampaignsIdRoute: AppCampaignsIdRoute,
  AppDisputesIdRoute: AppDisputesIdRoute,
  AppDisputesAlertsRoute: AppDisputesAlertsRoute,
  AppDisputesPolicyRoute: AppDisputesPolicyRoute,
  AppMeBalanceRoute: AppMeBalanceRoute,
  AppOrdersHistoryRoute: AppOrdersHistoryRoute,
  AppBrokersIndexRoute: AppBrokersIndexRoute,
  AppCampaignsIndexRoute: AppCampaignsIndexRoute,
  AppDisputesIndexRoute: AppDisputesIndexRoute,
  AppOrdersIndexRoute: AppOrdersIndexRoute,
  AppBrokersProviderCasesCaseIdRoute: AppBrokersProviderCasesCaseIdRoute,
  AppBrokersSettlementBrokerIdRoute: AppBrokersSettlementBrokerIdRoute,
  AppBrokersProviderCasesIndexRoute: AppBrokersProviderCasesIndexRoute,
  AppBrokersSettlementIndexRoute: AppBrokersSettlementIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
